import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Table,
  Breadcrumb,
  Input,
  Checkbox,
  Form,
  DatePicker,
  Tooltip,
  Collapse,
  Spin,
} from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, patchRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";

const VendorBidRFQ = () => {
  const { Panel } = Collapse;
  const { t } = useTranslation();
  const { id } = useParams();
  const formRef = useRef();
  const navigate = useNavigate();
  const vendorBidId = id ? atob(id) : null;
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [vendorBidRFQ, setVendorBidRFQ] = useState([]);
  const [vendorBidRFQ2, setVendorBidRFQ2] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [rfqnumber, setRFQNumber] = useState([]);
  const [rfqcurrency, setRFQCurrency] = useState([]);
  const [rfqfreight, setRFQFreight] = useState([]);
  const [rfqunloading, setRFQUnloading] = useState([]);
  const [rfqpricebasis, setRFQPriceBasis] = useState([]);
  const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);
  const [rfqopenorder, setRFQOpenOrder] = useState(false);
  const [rfqpricecap, setRFQPriceCap] = useState([]);
  const [rfqduedate, setRFQDueDate] = useState([]);
  const [rfqdeliveryenddate, setRFQDeliveryEndDate] = useState([]);
  const [rfqdeliverystartdate, setRFQDeliveryStartDate] = useState([]);
  const [rfqopendeliverydate, setRFQDeliveryDate] = useState([]);
  const [rfqtimelinecap, setRFQTimeLineCap] = useState([]);
  const [rfqamountcap, setRFQAmountCap] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const [isFinalBidPrice, setIsFinalBidPrice] = useState(true);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [newState2, setNewState2] = useState([]);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [isDatePickerDisabled, setIsDatePickerDisabled] = useState(false);
  const [isDatePickerDisabledR1, setIsDatePickerDisabledR1] = useState(false);
  const [siteGstRates, setSiteGstRates] = useState({});
  const [siteWithoutGstRates, setSiteWithoutGstRates] = useState({});

  const [totalGstInclusiveUnitRate, setTotalGstInclusiveUnitRate] = useState(0);
  const [totalWIthGst, setTotalWithGst] = useState(null);
  const [patchId, setPatchId] = useState(null);
  const [gstInitialValue, setGstInitialValue] = useState(false);
  const [trackingOfStages, setTrackingOfStages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [isSubmitClicked2, setIsSubmitClicked2] = useState(false);
  const [isSubmitClicked3, setIsSubmitClicked3] = useState(false);
  // const { Panel } = Collapse;

  const [apiLoading, setapiLoading] = useState(false);

  const [rfqData, setRfqData] = useState({
    open_order: false,
    rfqamountcap: "",
    rfqtimelinecap: "",
    rfqopendeliverydate: "",
    rfqdeliverystartdate: "",
    rfqdeliveryenddate: "",
    rfqduedate: "",
    rfqpricecap: "",
  });
  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  })();
  const initialState = {
    vendor: VendorId,
    is_final_bid_price: isFinalBidPrice,
    bid_rfq_vendor_detail: [
      {
        // rfq_material_type_name: null,
        // rfq_material_type_id: null,
        bid_rfq_detail: [
          {
            rfq_vendor_detail: null,
            initial_bid_price_unit_rate: null,
            initial_bid_price_unit_rate_of_freight: null,
            initial_bid_price_total_unit_rate: null,
            initial_bid_price_date: null,
            revised_bid_price_unit_rate: null,
            revised_bid_price_unit_rate_of_freight: null,
            revised_bid_price_total_unit_rate: null,
            revised_bid_price_date: null,
            final_bid_price_unit_rate: null,
            final_bid_price_unit_rate_of_freight: null,
            final_bid_price_total_unit_rate: null,
            final_bid_price_date: null,
            total_of_cement_R0: null,
            total_of_freight_R0: null,
            total_unit_rate_of_R0: null,
            total_of_cement_R1: null,
            total_of_freight_R1: null,
            total_unit_rate_of_R1: null,
            total_of_cement_R: null,
            total_of_freight_R: null,
            total_unit_rate_of_R: null,
            gst_inclusive_unit_rate: null,
            amount_without_gst: null,
            amount_with_gst: null,
          },
        ],
      },
    ],
  };

  const [state, setState] = useState(initialState);
  const [hideUnitRateOfCementR0, setHideUnitRateOfCementR0] = useState(false);
  const [hideUnitRateOfCementR1, setHideUnitRateOfCementR1] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [disabled1, setDisabled1] = useState(true);
  const [disabled2, setDisabled2] = useState(true);

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };
  const handleCheckboxhideR1 = () => {
    setHideUnitRateOfCementR0(!hideUnitRateOfCementR0);
  };
  const handleCheckboxhideR = () => {
    setHideUnitRateOfCementR1(!hideUnitRateOfCementR1);
  };

  const [buyingPattern, setBuyingPattern] = useState("");
  //const [hideUnitRateOfCementR0, setHideUnitRateOfCementR0] = useState(true);
  const [hideUnitRateOfFreightR0, setHideUnitRateOfFreightR0] = useState(true);
  const [gstRate, setGstRate] = useState(null); // State to store GST rate
  const [CategoryId, setCtaegoryTree] = useState();

  const [estimatedUnitPrice, setEstimatedUnitPrice] = useState(null); // State to store estimated unit price
  const [totalWithoutGST11, setTotalWithoutGST11] = useState(0);
  const [totalWithGST11, setTotalWithGST11] = useState(0);
  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          // `bid-rfq/${vendorBidId}/get-bid-rfq/`
          `bid-rfq/${vendorBidId}/get-bid-rfq/?vendor_id=${VendorId}`
          //`bid-rfq/${vendorBidId}/get-bid-rfq-by-vendor/?vendor_id=${VendorId}`
        );
        // const response = await getRequest(`bid-rfq/238/get-bid-rfq/`);
        if (response.data.data) {
          const responseData = response.data.data.rfq_site_wise_vendor;
          const CategoryId =
            response.data.data.rfq_site_wise_vendor[0].category_tree_id;
          setCtaegoryTree(CategoryId);
          const gstRate = response.data.data.rfq_site_wise_vendor[0].gst_rate;
          const estimatedUnitPrice =
            response.data.data.rfq_site_wise_vendor[0].estimated_unit_price;

          // setQuantity(quantity);
          setGstRate(gstRate);
          setEstimatedUnitPrice(estimatedUnitPrice);
          const pattern =
            response.data.data.rfq_site_wise_vendor[0].buying_pattern;
          //setBuyingPattern("Unit Rate of Cement & Unit Rate of Freight");
          setBuyingPattern(pattern);
          if (pattern === "Unit Rate of Cement") {
            setHideUnitRateOfCementR0(false);

            setHideUnitRateOfFreightR0(true);
          } else if (pattern === "Unit Rate of Cement & Unit Rate of Freight") {
            setHideUnitRateOfCementR0(false);
            setHideUnitRateOfFreightR0(false);
          } else if (pattern === "Total Unit Rate") {
            setHideUnitRateOfCementR0(false);
            setHideUnitRateOfFreightR0(true);
          }
          const calculateTotalR0 = (bid_rfq_detail) => {
            return bid_rfq_detail.reduce(
              (total, detail) => total + (parseFloat(detail.total_of_R0) || 0),
              0
            );
          };

          const newState = {
            vendor: VendorId,
            //buying_pattern: response.data.data.rfq_site_wise_vendor.buying_pattern,

            bid_rfq_vendor_detail: responseData.map((item) => ({
              buying_pattern: item.buying_pattern,
              // comment

              rfq_material_type_name: item.rfq_material_type_name,
              rfq_material_type: item.rfq_material_type_id,
              gst_rate: item.gst_rate,
              estimated_unit_price: item.estimated_unit_price,
              bid_rfq_detail: item.bid_rfq_site_detail.map((detail) => ({
                // bid_rfq_id: item.bid_rfq_id,
                purchase_requisition_site_id:
                  detail.purchase_requisition_site_id,
                rfq_vendor_detail: detail.rfq_vendor_detail_id, // Displaying "rfq_vendor_detail_id" as "rfq_vendor_detail"
                initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight,
                initial_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate,
                initial_bid_price_date: currentDate,
                revised_bid_price_unit_rate:
                  detail.initial_bid_price_unit_rate_R1,
                revised_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight_R1,
                revised_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate_of_R1,
                revised_bid_price_date:
                  trackingOfStages === 1 || trackingOfStages === 2
                    ? currentDate
                    : null,
                final_bid_price_unit_rate: detail.initial_bid_price_unit_rate_R,
                final_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight_R,
                final_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate_of_R,
                final_bid_price_date: detail.initial_bid_price_date_R,
                gst_inclusive_unit_rate: detail.gst_inclusive_unit_rate,
                amount_without_gst: detail.amount_without_gst,
                amount_with_gst: detail.amount_with_gst,
                //totalUnitRateOfCementR0: detail.totalUnitRateOfCementR0,
                //total_of_R0: detail.total_of_R0,
              })),

              // total_of_R0: item.bid_rfq_site_detail.reduce((total, detail) => total + (parseFloat(detail.total_of_R0) || 0), 0),
            })),
          };

          // Now, response.data contains the merged data with bid_rfq_id from newState

          console.log(newState, "NEWSTATE");
          setState((prevState) => ({
            ...prevState,
            ...newState,
          }));

          // Assuming response.data.data.rfq_site_wise_vendor is an array
          // const rfqVendorDetailIds = response.data.data.rfq_site_wise_vendor.flatMap(vendor =>
          //   vendor.bid_rfq_site_detail.map(detail => ({
          //     rfq_vendor_detail: detail.rfq_vendor_detail_id,
          //     initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate
          //   }))
          // );
          // setState(prevState => ({
          //   ...prevState,
          //   // bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(detail => ({
          //   //...detail,
          //   bid_rfq_vendor_detail: rfqVendorDetailIds,
          //   // }))
          // }));
          // console.log(rfqVendorDetailIds)
          //const companyName = response.data.data.rfq_site_wise_vendor.rfq_number;
          const tableData = responseData.map((item, index) => ({
            key: index,
            rfq_material_type_name: item.rfq_material_type_name,

            siteLocations: item.bid_rfq_site_detail.map((site) => ({
              name: site.purchase_requisition_site_name,
              quantity: site.site_wise_total_quantity,
              uom: site.rfq_uom,
            })),

            unitRateOfCement: item.bid_rfq_site_detail.reduce((acc, site) => {
              acc[site.purchase_requisition_site_name] =
                site.unit_rate_of_cement;
              return acc;
            }, {}),
          }));
          const tableData2 = response.data.data.rfq_site_wise_vendor.map(
            (item, index) => ({
              siteLocations:
                index === 0
                  ? item.bid_rfq_site_detail.map((site) => ({
                    name: site.purchase_requisition_site_name,
                    id: site.purchase_requisition_site_id,
                  }))
                  : null, // Set to null for other indices
            })
          );
          setVendorBidRFQ(tableData);
          setVendorBidRFQ2(tableData2);
          setCompanyName(responseData[0].company);

          setRFQNumber(responseData[0].rfq_number);
          setRFQCurrency(responseData[0].currency);
          setRFQPriceBasis(responseData[0].price_basis);
          setRFQFreight(responseData[0].freight);
          setRFQUnloading(responseData[0].unloading);
          setRFQTransportInsurance(responseData[0].transport_insurance);
          setRFQOpenOrder(responseData[0].open_order);

          setRFQPriceCap(responseData[0].price_cap);
          // setRFQAmountCap(responseData[0].amount_cap);
          // setRFQTimeLineCap(responseData[0].timeline_cap);
          // setRFQDeliveryDate(responseData[0].delivery_date);
          // setRFQDeliveryStartDate(responseData[0].delivery_start_date);
          // setRFQDeliveryEndDate(responseData[0].delivery_end_date);
          // setRFQDueDate(responseData[0].rfq_due_date);

          setRfqData({
            open_order: responseData[0].open_order,
            rfqamountcap: responseData[0].amount_cap,
            rfqtimelinecap: responseData[0].timeline_cap,
            rfqopendeliverydate: responseData[0].delivery_date,
            rfqdeliverystartdate: responseData[0].delivery_start_date,
            rfqdeliveryenddate: responseData[0].delivery_end_date,
            rfqduedate: responseData[0].rfq_due_date,
            rfqpricecap: responseData[0].price_cap,
          });
          console.log(rfqduedate, "RFQ DUE DATE");
        } else {
          ErrorNotificationMsg(t("error_in_rfq_history"));
        }
        setapiLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [vendorBidId]);

  // useEffect(() => {
  //   if (state && state.bid_rfq_vendor_detail) {
  //     const updatedRates = {};

  //     state.bid_rfq_vendor_detail.forEach((vendorDetail) => {
  //       vendorDetail.bid_rfq_site_detail.forEach((siteDetail) => {
  //         const siteName = siteDetail.site_name;
  //         const gstInclusiveUnitRate = siteDetail.gst_inclusive_unit_rate || 0;
  //         updatedRates[siteName] = gstInclusiveUnitRate;
  //       });
  //     });
  //     setSiteGstRates(updatedRates);
  //   }
  // }, [state]);
  useEffect(() => {
    if (state && state.bid_rfq_vendor_detail) {
      const updatedRates = {};
      const updatedRatesWithoutGst = {};

      let totalRate = 0;
      let totalRate2 = 0;

      state.bid_rfq_vendor_detail.forEach((vendorDetail) => {
        let totalGstInclusiveRatePerVendor = 0;
        let totalGstInclusiveRatePerVendor2 = 0;

        vendorDetail.bid_rfq_detail.forEach((siteDetail) => {
          const siteId = siteDetail.purchase_requisition_site_id;
          const gstInclusiveUnitRate = siteDetail.amount_with_gst;

          totalRate += gstInclusiveUnitRate;
          totalGstInclusiveRatePerVendor += gstInclusiveUnitRate;

          if (!isNaN(gstInclusiveUnitRate)) {
            // Accumulate the PO value for each site ID
            if (updatedRates[siteId]) {
              updatedRates[siteId] += Math.round(gstInclusiveUnitRate);
            } else {
              updatedRates[siteId] = Math.round(gstInclusiveUnitRate);
            }
          }
        });
      });

      state.bid_rfq_vendor_detail.forEach((vendorDetail) => {
        let totalGstInclusiveRatePerVendor2 = 0;

        vendorDetail.bid_rfq_detail.forEach((siteDetail) => {
          const siteId = siteDetail.purchase_requisition_site_id;
          const gstWithoutUnitRate = siteDetail.amount_without_gst;

          totalRate2 += gstWithoutUnitRate;
          totalGstInclusiveRatePerVendor2 += gstWithoutUnitRate;

          if (!isNaN(gstWithoutUnitRate)) {
            // Accumulate the PO value for each site ID
            if (updatedRatesWithoutGst[siteId]) {
              updatedRatesWithoutGst[siteId] += Math.round(gstWithoutUnitRate);
            } else {
              updatedRatesWithoutGst[siteId] = Math.round(gstWithoutUnitRate);
            }
          }
        });
      });

      // Update the state for the total rate after processing all vendors
      setTotalGstInclusiveUnitRate(totalRate || 0);

      // Update the state for siteGstRates with PO values for each site ID
      setSiteGstRates(updatedRates);
      setSiteWithoutGstRates(updatedRatesWithoutGst);
    }
  }, [state]);

  console.log('state 01', state);

  useEffect(() => {
    const { bid_rfq_vendor_detail } = state;

    if (trackingOfStages === 0) {
        let shouldDisable = true;

        for (let detail of bid_rfq_vendor_detail) {
            console.log('detail ', detail);

            for (let site of detail.bid_rfq_detail) {
                console.log(site);
                if (
                    site.initial_bid_price_total_unit_rate !== undefined && site.initial_bid_price_unit_rate_of_freight !== undefined
                ) {

                    shouldDisable = false;
                    setDisabled(false);
                    // break; // Exit the loop early if a valid bid price is found
                }else{
                  shouldDisable = true
                  setDisabled(true);

                }
            }
            // setDisabled(false);
            if (!shouldDisable) {
                // break; // Exit the outer loop early if a valid bid price is found
            }
        }

      
    }


    if (trackingOfStages === 1) {
      let shouldDisable = true;

      for (let detail of bid_rfq_vendor_detail) {
          console.log('detail ', detail);

          for (let site of detail.bid_rfq_detail) {
              console.log(site);

              if (
                  site.revised_bid_price_total_unit_rate !== undefined && site.revised_bid_price_unit_rate_of_freight !== undefined
              ) {
                  shouldDisable = false;
                  setDisabled1(false);
                  // break; // Exit the loop early if a valid bid price is found
              }else{
                shouldDisable = true
                setDisabled1(true);

              }
          }
          // setDisabled(false);
          if (!shouldDisable) {
              // break; // Exit the outer loop early if a valid bid price is found
          }
      }

    
  }

  if (trackingOfStages === 2) {
    let shouldDisable = true;

    for (let detail of bid_rfq_vendor_detail) {
        console.log('detail ', detail);

        for (let site of detail.bid_rfq_detail) {
            console.log(site);

            if (
                site.final_bid_price_total_unit_rate !== undefined && site.final_bid_price_unit_rate_of_freight !== undefined
            ) {

                shouldDisable = false;
                setDisabled2(false);
                // break; // Exit the loop early if a valid bid price is found
            }else{
              shouldDisable = true
              setDisabled2(true);

            }
        }
        // setDisabled(false);
        if (!shouldDisable) {
            // break; // Exit the outer loop early if a valid bid price is found
        }
    }

  
}



}, [state, trackingOfStages]); // Added trackingOfStages as a dependency to useEffect


  const [syncAllR, setSyncAllR] = useState(false);
  const onUnitRateOfCementCheckboxChangeR = (e) => {
    //setIsUnitRateOfCementChecked(e.target.checked);
    // You can also perform other actions based on the checkbox state
    const isChecked = e.target.checked;
    setSyncAllR(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRate = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.final_bid_price_unit_rate
        : null;
      // const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.final_bid_price_unit_rate_of_freight
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate_of_freight +
      //   prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate
      //   : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate;
      // const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.final_bid_price_unit_rate_of_freight
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate_of_freight
      //   : null;
      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfCement = isChecked ? firstUnitRate : null;
            // const totalUnitRate = isChecked
            //   ? (site.final_bid_price_unit_rate_of_freight || 0) + (updatedUnitRateOfCement || 0) : null;
            const totalUnitRate = isChecked
              ? (site.final_bid_price_unit_rate_of_freight || 0) +
              (updatedUnitRateOfCement || 0)
              : site.final_bid_price_unit_rate_of_freight || 0; // Set to existing value if not checked

            return {
              ...site,
              final_bid_price_unit_rate: updatedUnitRateOfCement,
              final_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );

      // return {
      //   ...prevState,
      //   bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
      //     (vendor) => ({
      //       ...vendor,
      //       bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
      //         ...site,
      //         final_bid_price_unit_rate: isChecked ? firstUnitRate : null, // Set all to the first value or null based on the checkbox status
      //         final_bid_price_total_unit_rate: isChecked
      //           ? secondInitialBidTotalUnitRate
      //           : uncheckCondition,
      //         //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
      //         //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
      //       })),
      //     })
      //   ),
      // };
      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };
  const [syncAll, setSyncAll] = useState(false);
  const onUnitRateOfCementCheckboxChangeR0 = (e) => {
    const isChecked = e.target.checked;
    setSyncAll(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRate = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.initial_bid_price_unit_rate
        : null;

      // const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map((vendor) => ({
      //   ...vendor,
      //   bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
      //     ...site,
      //     initial_bid_price_unit_rate: isChecked ? firstUnitRate : null,
      //   })),
      // }));

      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfCement = isChecked ? firstUnitRate : null;
            // const totalUnitRate = isChecked
            //   ? (site.initial_bid_price_unit_rate_of_freight || 0) + (updatedUnitRateOfCement || 0) : null;
            const totalUnitRate = isChecked
              ? (site.initial_bid_price_unit_rate_of_freight || 0) +
              (updatedUnitRateOfCement || 0)
              : site.initial_bid_price_unit_rate_of_freight || 0; // Set to existing value if not checked

            return {
              ...site,
              initial_bid_price_unit_rate: updatedUnitRateOfCement,
              initial_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );

      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };
  // const onUnitRateOfCementCheckboxChangeR0 = (e) => {
  //   const isChecked = e.target.checked;
  //   setSyncAll(isChecked); // Update the state to reflect the checkbox's status
  //   setState((prevState) => {
  //     const firstUnitRate = isChecked
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate
  //       : null;

  //     const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
  //       ?.bid_rfq_detail[0]?.initial_bid_price_unit_rate_of_freight
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate_of_freight +
  //       prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate
  //       : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate;

  //     const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
  //       ?.bid_rfq_detail[0]?.initial_bid_price_unit_rate_of_freight
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate_of_freight
  //       : null;
  //     return {
  //       ...prevState,
  //       bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
  //         (vendor) => ({
  //           ...vendor,
  //           bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
  //             ...site,
  //             initial_bid_price_unit_rate: isChecked ? firstUnitRate : null, // Set all to the first value or null based on the checkbox status
  //             initial_bid_price_total_unit_rate: isChecked
  //               ? secondInitialBidTotalUnitRate
  //               : uncheckCondition,
  //             //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
  //             //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
  //           })),
  //         })
  //       ),
  //     };
  //   });
  // };
  const [syncAllR1, setSyncAllR1] = useState(false);
  const onUnitRateOfCementCheckboxChangeR1 = (e) => {
    const isChecked = e.target.checked;
    setSyncAllR1(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRate = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.revised_bid_price_unit_rate
        : null;

      // const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.revised_bid_price_unit_rate_of_freight
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate +
      //   prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate_of_freight
      //   : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate;

      // const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.revised_bid_price_unit_rate_of_freight
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate_of_freight
      //   : null;

      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfCement = isChecked ? firstUnitRate : null;
            // const totalUnitRate = isChecked
            //   ? (site.revised_bid_price_unit_rate_of_freight || 0) + (updatedUnitRateOfCement || 0) : null;
            const totalUnitRate = isChecked
              ? (site.revised_bid_price_unit_rate_of_freight || 0) +
              (updatedUnitRateOfCement || 0)
              : site.revised_bid_price_unit_rate_of_freight || 0; // Set to existing value if not checked

            return {
              ...site,
              revised_bid_price_unit_rate: updatedUnitRateOfCement,
              revised_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );

      // return {
      //   ...prevState,
      //   bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
      //     (vendor) => ({
      //       ...vendor,
      //       bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
      //         ...site,
      //         revised_bid_price_unit_rate: isChecked ? firstUnitRate : null,
      //         revised_bid_price_total_unit_rate: isChecked
      //           ? secondInitialBidTotalUnitRate
      //           : uncheckCondition, // Set all to the first value or null based on the checkbox status
      //         //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
      //         //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
      //       })),
      //     })
      //   ),
      // };
      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };
  const [syncAllFreightR, setSyncAllFreightR] = useState(false);
  const onUnitRateOfFrieghtCheckboxChangeR = (e) => {
    const isChecked = e.target.checked;
    setSyncAllFreightR(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRate = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.final_bid_price_unit_rate_of_freight
        : null;
      // const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.final_bid_price_unit_rate
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate +
      //   prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate_of_freight
      //   : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate_of_freight;

      // const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.final_bid_price_unit_rate
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.final_bid_price_unit_rate
      //   : null;
      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfFreight = isChecked ? firstUnitRate : null;
            // const totalUnitRate = isChecked
            //   ? (site.final_bid_price_unit_rate || 0) + (updatedUnitRateOfFreight || 0) : null;
            const totalUnitRate = isChecked
              ? (site.final_bid_price_unit_rate || 0) +
              (updatedUnitRateOfFreight || 0)
              : site.final_bid_price_unit_rate || 0; // Set to existing value if not checked

            return {
              ...site,
              final_bid_price_unit_rate_of_freight: updatedUnitRateOfFreight,
              final_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );

      // return {
      //   ...prevState,
      //   bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
      //     (vendor) => ({
      //       ...vendor,
      //       bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
      //         ...site,
      //         final_bid_price_unit_rate_of_freight: isChecked
      //           ? firstUnitRate
      //           : null, // Set all to the first value or null based on the checkbox status
      //         final_bid_price_total_unit_rate: isChecked
      //           ? secondInitialBidTotalUnitRate
      //           : uncheckCondition,
      //         //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
      //         //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
      //       })),
      //     })
      //   ),
      // };

      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };
  const [syncAllFreightR0, setSyncAllFreightR0] = useState(false);

  // const onUnitRateOfFrieghtCheckboxChangeR0 = (e) => {
  //   const isChecked = e.target.checked;
  //   setSyncAllFreightR0(isChecked); // Update the state to reflect the checkbox's status
  //   setState((prevState) => {
  //     const firstUnitRate = isChecked
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate_of_freight
  //       : null;

  //     const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
  //       ?.bid_rfq_detail[0]?.initial_bid_price_unit_rate
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate +
  //       prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate_of_freight
  //       : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate_of_freight;

  //     console.log(secondInitialBidTotalUnitRate, "second initial state")
  //     const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
  //       ?.bid_rfq_detail[0]?.initial_bid_price_unit_rate
  //       ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
  //         ?.initial_bid_price_unit_rate
  //       : null;
  //     return {
  //       ...prevState,
  //       bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
  //         (vendor) => ({
  //           ...vendor,
  //           bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
  //             ...site,
  //             initial_bid_price_unit_rate_of_freight: isChecked
  //               ? firstUnitRate
  //               : null, // Set all to the first value or null based on the checkbox status
  //             initial_bid_price_total_unit_rate: isChecked
  //               ? secondInitialBidTotalUnitRate
  //               : uncheckCondition,
  //             //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
  //             //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
  //           })),
  //         })
  //       ),
  //     };
  //   });
  // };

  const onUnitRateOfFrieghtCheckboxChangeR0 = (e) => {
    const isChecked = e.target.checked;
    setSyncAllFreightR0(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRateOfFreight = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.initial_bid_price_unit_rate_of_freight
        : null;

      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfFreight = isChecked
              ? firstUnitRateOfFreight
              : null;
            // const totalUnitRate = isChecked
            //   ? (site.initial_bid_price_unit_rate || 0) + (updatedUnitRateOfFreight || 0) : null;
            const totalUnitRate = isChecked
              ? (site.initial_bid_price_unit_rate || 0) +
              (updatedUnitRateOfFreight || 0)
              : site.initial_bid_price_unit_rate || 0; // Set to existing value if not checked

            return {
              ...site,
              initial_bid_price_unit_rate_of_freight: updatedUnitRateOfFreight,
              initial_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );

      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };

  const [syncAllFreightR1, setSyncAllFreightR1] = useState(false);

  const onUnitRateOfFreightCheckboxChangeR1 = (e) => {
    const isChecked = e.target.checked;
    setSyncAllFreightR1(isChecked); // Update the state to reflect the checkbox's status
    setState((prevState) => {
      const firstUnitRateOfFreight = isChecked
        ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
          ?.revised_bid_price_unit_rate_of_freight
        : null;
      // const secondInitialBidTotalUnitRate = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.revised_bid_price_unit_rate
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate +
      //   prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate_of_freight
      //   : prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate_of_freight;
      // const uncheckCondition = prevState.bid_rfq_vendor_detail[0]
      //   ?.bid_rfq_detail[0]?.revised_bid_price_unit_rate
      //   ? prevState.bid_rfq_vendor_detail[0]?.bid_rfq_detail[0]
      //     ?.revised_bid_price_unit_rate
      //   : null;
      const updatedVendorDetail = prevState.bid_rfq_vendor_detail.map(
        (vendor) => ({
          ...vendor,
          bid_rfq_detail: vendor.bid_rfq_detail.map((site) => {
            const updatedUnitRateOfFreight = isChecked
              ? firstUnitRateOfFreight
              : null;
            // const totalUnitRate = isChecked
            //   ? (site.revised_bid_price_unit_rate || 0) + (updatedUnitRateOfFreight || 0) : null;
            const totalUnitRate = isChecked
              ? (site.revised_bid_price_unit_rate || 0) +
              (updatedUnitRateOfFreight || 0)
              : site.revised_bid_price_unit_rate || 0; // Set to existing value if not checked

            return {
              ...site,
              revised_bid_price_unit_rate_of_freight: updatedUnitRateOfFreight,
              revised_bid_price_total_unit_rate: totalUnitRate,
            };
          }),
        })
      );
      // return {
      //   ...prevState,
      //   bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
      //     (vendor) => ({
      //       ...vendor,
      //       bid_rfq_detail: vendor.bid_rfq_detail.map((site) => ({
      //         ...site,
      //         revised_bid_price_unit_rate_of_freight: isChecked
      //           ? firstUnitRate
      //           : null, // Set all to the first value or null based on the checkbox status
      //         revised_bid_price_total_unit_rate: isChecked
      //           ? secondInitialBidTotalUnitRate
      //           : uncheckCondition,
      //         //revised_bid_price_unit_rate: isChecked ? firstUnitRate : site.revised_bid_price_unit_rate, // Set revised_bid_price_unit_rate to the same value if isChecked is true
      //         //final_bid_price_unit_rate: isChecked ? firstUnitRate : site.final_bid_price_unit_rate,  // Set final_bid_price_unit_rate to the same value if isChecked is true
      //       })),
      //     })
      //   ),
      // };
      return {
        ...prevState,
        bid_rfq_vendor_detail: updatedVendorDetail,
      };
    });
  };

  const handleUnitRateOfCementChangeR0 = (
    value,
    vendorIndex,
    siteIndex,
    gstRate,
    quantity
  ) => {
    // console.log(gstRate, "11")
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                // console.log(quantity, "OKOK")
                const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                // const quantity = quantityData[vendorIndex].bid_rfq_site_detail[siteIndex].site_wise_total_quantity || 0;
                // console.log(quantity, "Quantity Rate")
                // response.data.data.rfq_site_wise_vendor.forEach((vendor, vendorIndex) => {
                //   // Iterate over the bid_rfq_site_detail array for each vendor
                //   vendor.bid_rfq_site_detail.forEach((site, siteIndex) => {
                //     // Access the site_wise_total_quantity for each site and set it in state
                //     const quantity = site.site_wise_total_quantity;
                //     setQuantity(quantity); // Set quantity state
                //     console.log(`Vendorssss ${vendorIndex + 1}, Sitessss ${siteIndex + 1} Quantityssss: ${quantity}`);
                //   });
                // });

                const gstInclusiveUnitRate =
                  initialBidPriceUnitRate * quantity * (gstRate / 100) +
                  initialBidPriceUnitRate;

                // console.log(gstInclusiveUnitRate, "GST")
                // return {
                //   ...site,
                //   initial_bid_price_unit_rate: value, // Update the initial_bid_price_unit_rate for this site
                //   // gst_inclusive_unit_rate: ((value || 0) * gstRate * estimatedUnitPrice) / 100 // Calculate GST-inclusive unit rate
                //   gst_inclusive_unit_rate: (value+((value || 0) * gstRate ) / 100)
                // };
                return {
                  ...site,
                  initial_bid_price_unit_rate: initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                  gst_inclusive_unit_rate: gstInclusiveUnitRate, // Update the GST-inclusive unit rate for this site

                  // initial_bid_price_total_unit_rate :initialBidPriceUnitRate,
                  initial_bid_price_total_unit_rate:
                    site.initial_bid_price_unit_rate_of_freight
                      ? site.initial_bid_price_unit_rate_of_freight +
                      initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };

  const handleUnitRateOfCementChangeR1 = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                // return {
                //   ...site,
                //   revised_bid_price_unit_rate: value // Update the initial_bid_price_unit_rate for this site
                // };
                const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                const gstInclusiveUnitRate =
                  initialBidPriceUnitRate +
                  (initialBidPriceUnitRate * gstRate) / 100;

                // const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                // const gstInclusiveUnitRate = initialBidPriceUnitRate + (initialBidPriceUnitRate * gstRate / 100);

                return {
                  ...site,
                  revised_bid_price_unit_rate: initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                  gst_inclusive_unit_rate: gstInclusiveUnitRate, // Update the GST-inclusive unit rate for this site
                  // 2222
                  // initial_bid_price_total_unit_rate :initialBidPriceUnitRate,
                  revised_bid_price_total_unit_rate:
                    site.revised_bid_price_unit_rate_of_freight
                      ? site.revised_bid_price_unit_rate_of_freight +
                      initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
                // return {
                //   ...site,
                //   revised_bid_price_unit_rate: initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                //   gst_inclusive_unit_rate: gstInclusiveUnitRate // Update the GST-inclusive unit rate for this site
                // };
              }),
            };
          }
        ),
      };
    });
  };
  const handleUnitRateOfCementChangeR = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                // const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                // const gstInclusiveUnitRate = initialBidPriceUnitRate + (initialBidPriceUnitRate * gstRate / 100);
                // return {
                //   ...site,
                //   //revised_bid_price_unit_rate: initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                //   gst_inclusive_unit_rate: gstInclusiveUnitRate, // Update the GST-inclusive unit rate for this site
                //   revised_bid_price_unit_rate: site.final_bid_price_unit_rate_of_freight ? (site.final_bid_price_unit_rate_of_freight + initialBidPriceUnitRate) : initialBidPriceUnitRate// Update the initial_bid_price_unit_rate for this site
                // };

                const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                const gstInclusiveUnitRate =
                  initialBidPriceUnitRate +
                  (initialBidPriceUnitRate * gstRate) / 100;

                // const initialBidPriceUnitRate = parseFloat(value); // Parse the value to ensure it's a number
                // const gstInclusiveUnitRate = initialBidPriceUnitRate + (initialBidPriceUnitRate * gstRate / 100);

                return {
                  ...site,
                  final_bid_price_unit_rate: initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                  gst_inclusive_unit_rate: gstInclusiveUnitRate, // Update the GST-inclusive unit rate for this site
                  // initial_bid_price_total_unit_rate :initialBidPriceUnitRate,
                  final_bid_price_total_unit_rate:
                    site.final_bid_price_unit_rate_of_freight
                      ? site.final_bid_price_unit_rate_of_freight +
                      initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
                // return {
                //   ...site,
                //   final_bid_price_unit_rate: value // Update the initial_bid_price_unit_rate for this site
                // };
              }),
            };
          }
        ),
      };
    });
  };
  const handleUnitRateOfFreightChangeR0 = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                const initialBidPriceUnitRate = parseFloat(value);
                // console.log("Freight", initialBidPriceUnitRate);
                // console.log("Cement", site.initial_bid_price_unit_rate);

                return {
                  ...site,
                  initial_bid_price_unit_rate_of_freight:
                    initialBidPriceUnitRate,
                  initial_bid_price_total_unit_rate:
                    site.initial_bid_price_unit_rate
                      ? site.initial_bid_price_unit_rate +
                      initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };

  const handleTotalUnitRateR0Change = (value, vendorIndex, siteIndex) => {
    // console.log(value)
    const newState = { ...state };
    newState.bid_rfq_vendor_detail[vendorIndex].bid_rfq_detail[
      siteIndex
    ].initial_bid_price_total_unit_rate = parseFloat(value);
    setState(newState);
    // setState(prevState => {
    //   return {
    //     ...prevState,
    //     bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map((vendor, idx) => {
    //       if (idx !== vendorIndex) {
    //         return vendor; // If this vendor is not the one being updated, return it unchanged
    //       }
    //       return {
    //         ...vendor,
    //         bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
    //           if (sIdx !== siteIndex) {
    //             return site; // If this site is not the one being updated, return it unchanged
    //           }
    //           return {
    //             ...site,
    //             initial_bid_price_total_unit_rate: value // Update the initial_bid_price_unit_rate for this site
    //           };
    //         })
    //       };

    //     })
    //   };

    // });
  };

  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, siteIndex) => (
              <Input
                min={0}
                key={site.name + siteIndex}
                disabled={enableInputs}
                prefix={<RupeesSign />}
                style={{ width: "140px" }}
                placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                value={
                  // syncAll
                  //   ? state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                  //     siteIndex
                  //   ]?.initial_bid_price_unit_rate
                  //   : site.initial_bid_price_unit_rate

                  state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                    siteIndex
                  ]?.initial_bid_price_unit_rate
                }
                onChange={(e) =>
                  handleUnitRateOfCementChangeR0(
                    e.target.value,
                    record.key,
                    siteIndex,
                    state.bid_rfq_vendor_detail[record.key]?.gst_rate,
                    site.quantity
                  )
                }
                type="number"
              />
            ))}
            <div className="lbllightred">
              <Input
                placeholder={`Total Unit Rate of Cement R0`}
                prefix={<RupeesSign />}
                value={calculateTotalUnitRateOfCementR0(record)} // Assuming unit_rate_of_cement is a property in the record
                style={{ width: "140px" }} // Adjust width as needed
                disabled
              />
            </div>
          </div>
        </>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    // console.log(record.total_of_R0)
    const totalUnitRateOfCement = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.initial_bid_price_unit_rate) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfCement;
    state.bid_rfq_vendor_detail[record.key].total_of_cement_R0 = totalUnitRate;

    return totalUnitRateOfCement;
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              min={0}
              key={site.name + siteIndex}
              disabled={enableInputs}
              prefix={<RupeesSign />}
              style={{ width: "140px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={
                // syncAllFreightR0
                //   ? state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                //     siteIndex
                //   ]?.initial_bid_price_unit_rate_of_freight
                //   : site.initial_bid_price_unit_rate_of_freight

                state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                  siteIndex
                ]?.initial_bid_price_unit_rate_of_freight
              }
              onChange={(e) =>
                handleUnitRateOfFreightChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        {/* <Input
          placeholder={`Total Unit Rate of Freight R0`}
          value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: '300px', top: '10px' }} // Adjust width as needed
          disabled
        // Add onChange handler if needed
        
        /> */}
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate of Freight R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfFreightR0(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };
  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.initial_bid_price_unit_rate_of_freight) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfFreightR0;
    state.bid_rfq_vendor_detail[record.key].total_of_freight_R0 = totalUnitRate;

    return totalUnitRateOfFreightR0;
  };
  const renderUnitRateOfTotalUnitRateR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => {
            const unitRate =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].initial_bid_price_unit_rate
              ) || 0;
            const unitRateOfFreight =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].initial_bid_price_unit_rate_of_freight
              ) || 0;
            const totalUnitRate = unitRate + unitRateOfFreight;

            return (
              <Input
                key={site.name + siteIndex}
                disabled
                prefix={<RupeesSign />}
                style={{ width: "140px" }}
                placeholder={`Enter Total Unit Rate for ${site.name}`}
                value={totalUnitRate.toFixed(2)} // Display the total unit rate with 2 decimal places
                // onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
                type="number"
              />
            );
          })}
        </div>
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfR0(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };
  const calculateTotalUnitRateOfR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    // Return the sum of the two totals
    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(2);
  };

  // const calculateTotalUnitRateOfR0 = (record) => {
  //   const totalUnitRateOfCement = state?.bid_rfq_vendor_detail[record?.key]?.bid_rfq_detail?.reduce(
  //     (total, site) => total + (parseFloat(site?.initial_bid_price_total_unit_rate) || 0),
  //     0
  //   );
  //   let totalUnitRate = totalUnitRateOfCement;
  //   state.bid_rfq_vendor_detail[record.key].total_unit_rate_of_R0 = totalUnitRate;

  //   return totalUnitRateOfCement;
  // };
  const renderUnitRateOfCementR1 = (siteLocations, record) => {
    return (
      <>
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, siteIndex) => (
              <Input
                min={0}
                key={site.name + siteIndex}
                prefix={<RupeesSign />}
                disabled={enableInputsR1}
                style={{ width: "140px" }}
                placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                // value={
                value={
                  // syncAllR1
                  //   ? state?.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  //     siteIndex
                  //   ]?.revised_bid_price_unit_rate
                  //   : site.revised_bid_price_unit_rate

                  state?.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                    siteIndex
                  ]?.revised_bid_price_unit_rate
                }
                // } // Assuming only one vendor and one site
                onChange={(e) =>
                  handleUnitRateOfCementChangeR1(
                    e.target.value,
                    record.key,
                    siteIndex,
                    state.bid_rfq_vendor_detail[record.key]?.gst_rate,
                    site.quantity
                  )
                }
                type="number"
              />
            ))}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* <Input
              placeholder={`Total Unit Rate of Cement R1`}
              value={record.total_unit_rate_of_cement_R1} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: '300px', top: '10px' }} // Adjust width as needed
              disabled
            // Add onChange handler if needed
            /> */}
            <div className="lbllightred">
              <Input
                placeholder={`Total Unit Rate of Cement R1`}
                prefix={<RupeesSign />}
                value={calculateTotalUnitRateOfCementR1(record)} // Assuming unit_rate_of_cement is a property in the record
                style={{ width: "140px", top: "10px" }} // Adjust width as needed
                disabled
              />
            </div>
          </div>
        </>
      </>
    );
  };
  // const calculateTotalUnitRateOfCementR1 = (record) => {

  //   const totalUnitRateOfCement = state?.bid_rfq_vendor_detail[record?.key]?.bid_rfq_detail?.reduce(
  //     (total, site) => total + (parseFloat(site?.revised_bid_price_unit_rate) || 0),
  //     0
  //   );
  //   let totalUnitRate = totalUnitRateOfCement;
  //   state.bid_rfq_vendor_detail[record.key].total_of_cement_R1 = totalUnitRate;

  //   return totalUnitRateOfCement;
  // };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCement = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.revised_bid_price_unit_rate) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfCement;
    state.bid_rfq_vendor_detail[record.key].total_of_cement_R1 = totalUnitRate;

    return totalUnitRateOfCement;
  };

  const handleUnitRateOfFreightChangeR1 = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                const initialBidPriceUnitRate = parseFloat(value);

                return {
                  ...site,
                  revised_bid_price_unit_rate_of_freight:
                    initialBidPriceUnitRate,
                  revised_bid_price_total_unit_rate:
                    site.revised_bid_price_unit_rate
                      ? site.revised_bid_price_unit_rate +
                      initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
                // return {
                //   ...site,
                //   revised_bid_price_unit_rate_of_freight: value // Update the initial_bid_price_unit_rate for this site
                // };
              }),
            };
          }
        ),
      };
    });
  };
  const handleUnitRateOfFreightChangeR = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                // return {
                //   ...site,
                //   final_bid_price_unit_rate_of_freight: value // Update the initial_bid_price_unit_rate for this site
                // };
                const initialBidPriceUnitRate = parseFloat(value);

                return {
                  ...site,
                  final_bid_price_unit_rate_of_freight: initialBidPriceUnitRate,
                  final_bid_price_total_unit_rate:
                    site.final_bid_price_unit_rate
                      ? site.final_bid_price_unit_rate + initialBidPriceUnitRate
                      : initialBidPriceUnitRate, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };

  //   return (
  //     <>
  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //         {siteLocations.map((site, index) => (
  //           <Input
  //             key={index}
  //             disabled={enableInputsR1}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             placeholder={`Enter Unit Rate of Freight for ${site.name}`}
  //             value={record.unit_rate_of_freight}
  //           // Add onChange handler if needed
  //           />
  //         ))}
  //       </div>
  //       <Input
  //         placeholder={`Total Unit Rate of Freight R1`}
  //         value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
  //         style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //         disabled
  //       // Add onChange handler if needed
  //       />
  //     </>
  //   )
  // };
  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              min={0}
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ width: "140px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={
                // syncAllFreightR1
                //   ? state?.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                //     siteIndex
                //   ]?.revised_bid_price_unit_rate_of_freight
                //   : site.revised_bid_price_unit_rate_of_freight

                state?.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                  siteIndex
                ]?.revised_bid_price_unit_rate_of_freight
              } // Assuming only one vendor and one site
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate of Freight R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfFreightR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };
  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.revised_bid_price_unit_rate_of_freight) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfFreightR1;
    state.bid_rfq_vendor_detail[record.key].total_of_freight_R1 = totalUnitRate;

    return totalUnitRateOfFreightR1;
  };

  // const calculateTotalUnitRateOfCementR0 = (record) => {
  //   const totalUnitRateOfCement = state?.bid_rfq_vendor_detail[record?.key]?.bid_rfq_detail?.reduce(
  //     (total, site) => total + (parseFloat(site?.initial_bid_price_unit_rate) || 0),
  //     0
  //   );
  //   let totalUnitRate = totalUnitRateOfCement;
  //   state.bid_rfq_vendor_detail[record.key].total_of_cement_R0 = totalUnitRate;

  //   return totalUnitRateOfCement;
  // };

  const handleTotalUnitRateOfCementR1Change = (
    value,
    vendorIndex,
    siteIndex
  ) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                return {
                  ...site,
                  revised_bid_price_total_unit_rate: value, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };
  // const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
  //   return (
  //     <>
  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //         {siteLocations.map((site, index) => (
  //           <Input
  //             key={index}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             disabled={enableInputsR1}
  //             placeholder={`Enter Total Unit Rate for ${site.name}`}
  //             value={record.total_unit_rate}
  //           // Add onChange handler if needed
  //           />
  //         ))}
  //       </div>
  //       <Input
  //         placeholder={`Total Unit Rate R1`}
  //         value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
  //         style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //         disabled
  //       // Add onChange handler if needed
  //       />
  //     </>
  //   )
  // };
  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{  width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              //value={state.bid_rfq_vendor_detail[record.key].bid_rfq_detail.revised_bid_price_total_unit_rate} // Assuming only one vendor and one site
              value={
                parseFloat(
                  state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                    siteIndex
                  ].revised_bid_price_unit_rate
                ) &&
                  parseFloat(
                    state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                      siteIndex
                    ].revised_bid_price_unit_rate_of_freight
                  )
                  ? (
                    parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].revised_bid_price_unit_rate
                    ) +
                    parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].revised_bid_price_unit_rate_of_freight
                    )
                  ).toFixed(2) // If both initial_bid_price_unit_rate and initial_bid_price_unit_rate_of_freight exist, display their total
                  : parseFloat(
                    state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                      siteIndex
                    ].revised_bid_price_unit_rate
                  )
                    ? parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].revised_bid_price_unit_rate
                    ).toFixed(2) // If only initial_bid_price_unit_rate exists, display it
                    : parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].revised_bid_price_unit_rate_of_freight
                    ).toFixed(2) // If only initial_bid_price_unit_rate_of_freight exists, display it
              }
              //onChange={(e) => handleTotalUnitRateOfCementR1Change(e.target.value, record.key, siteIndex)}
              type="number"
            />
          ))}
        </div> */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => {
            const unitRate =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].revised_bid_price_unit_rate
              ) || 0;
            const unitRateOfFreight =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].revised_bid_price_unit_rate_of_freight
              ) || 0;
            const totalUnitRate = unitRate + unitRateOfFreight;

            return (
              <Input
                key={site.name + siteIndex}
                disabled={enableInputsR1}
                prefix={<RupeesSign />}
                style={{ width: "140px" }}
                placeholder={`Enter Total Unit Rate for ${site.name}`}
                value={totalUnitRate.toFixed(2)} // Display the total unit rate with 2 decimal places
                // onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
                type="number"
              />
            );
          })}
        </div>
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate of R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
        {/* <Input
          placeholder={`Total Unit Rate of R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfR1(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: '300px', top: '10px' }} // Adjust width as needed
          disabled
        /> */}
      </>
    );
  };
  // const calculateTotalUnitRateOfR1 = (record) => {
  //   const totalUnitRateOfFreightR1 = state?.bid_rfq_vendor_detail[record?.key]?.bid_rfq_detail?.reduce(
  //     (total, site) => total + (parseFloat(site?.revised_bid_price_total_unit_rate) || 0),
  //     0
  //   );
  //   let totalUnitRate = totalUnitRateOfFreightR1;
  //   state.bid_rfq_vendor_detail[record.key].total_unit_rate_of_R1 = totalUnitRate;

  //   return totalUnitRateOfFreightR1;
  // };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    // Return the sum of the two totals
    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(2);
  };

  const [showInitialBidPriceR0, setShowInitialBidPriceR0] = useState(true); // Assuming default visibility
  const [showRevisedBidPriceR1, setShowRevisedBidPriceR1] = useState(true); // Assuming default visibility

  const handleShowInitialBidPriceR0Change = () => {
    setShowInitialBidPriceR0(!showInitialBidPriceR0);
  };

  // Function to handle change for Revised BID Price - R1 Checkbox
  const handleShowRevisedBidPriceR1Change = () => {
    setShowRevisedBidPriceR1(!showRevisedBidPriceR1);
  };

  // const renderUnitRateOfCementR = (siteLocations, record) => {
  //   return (
  //     <>
  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //         {siteLocations.map((site, index) => (
  //           <Input
  //             key={index}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             placeholder={`Enter Unit Rate of Cement for ${site.name}`}
  //             value={record.unitRateOfCement[site]}
  //           // Add onChange handler if needed
  //           />
  //         ))}
  //       </div>
  //       <div style={{ display: 'flex', flexDirection: 'column', }}>
  //         <Input
  //           placeholder={`Total Unit Rate of Cement R`}
  //           value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
  //           style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //           disabled
  //         // Add onChange handler if needed
  //         />
  //       </div>
  //     </>
  //   );
  // };
  const renderUnitRateOfCementR = (siteLocations, record) => {
    return (
      <>
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, siteIndex) => (
              <Input
                key={site.name + siteIndex}
                prefix={<RupeesSign />}
                min={0}
                //disabled={enableInputs}
                style={{ width: "140px" }}
                placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                value={
                  // syncAllR
                  //   ? state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  //     siteIndex
                  //   ].final_bid_price_unit_rate
                  //   : site.final_bid_price_unit_rate
                  state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                    siteIndex
                  ].final_bid_price_unit_rate
                } // Assuming only one vendor and one site
                onChange={(e) =>
                  handleUnitRateOfCementChangeR(
                    e.target.value,
                    record.key,
                    siteIndex,
                    state.bid_rfq_vendor_detail[record.key]?.gst_rate,
                    site.quantity
                  )
                }
                type="number"
              />
            ))}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* <Input
              placeholder={`Total Unit Rate of Cement R`}
              value={record.total_unit_rate_of_cement_R} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: '300px', top: '10px' }} // Adjust width as needed
              disabled
            // Add onChange handler if needed
            /> */}
            <Input
              placeholder={`Total Unit Rate of R`}
              prefix={<RupeesSign />}
              value={calculateTotalUnitRateOfCementR(record)} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: "140px", top: "10px" }} // Adjust width as needed
              disabled
            />
          </div>
        </>
      </>
    );
  };
  const calculateTotalUnitRateOfCementR = (record) => {
    const totalUnitRateOfCementR = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.final_bid_price_unit_rate) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfCementR;
    state.bid_rfq_vendor_detail[record.key].total_of_cement_R = totalUnitRate;

    return totalUnitRateOfCementR;
  };

  // const renderUnitRateOfFreightR = (siteLocations, record) => {
  //   return (
  //     <>
  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //         {siteLocations.map((site, index) => (
  //           <Input
  //             key={index}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             placeholder={`Enter Unit Rate of Freight for ${site.name}`}
  //             value={record.unit_rate_of_freight}
  //           // Add onChange handler if needed
  //           />
  //         ))}
  //       </div>
  //       <Input
  //         placeholder={`Total Unit Rate of Freight R`}
  //         value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
  //         style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //         disabled
  //       // Add onChange handler if needed
  //       />
  //     </>
  //   )
  // };
  const renderUnitRateOfFreightR = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              min={0}
              //disabled={enableInputsR1}
              style={{ width: "140px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={
                // syncAllFreightR
                //   ? state?.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                //     siteIndex
                //   ]?.final_bid_price_unit_rate_of_freight
                //   : site.final_bid_price_unit_rate_of_freight

                state?.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                  siteIndex
                ]?.final_bid_price_unit_rate_of_freight
              } // Assuming only one vendor and one site
              onChange={(e) =>
                handleUnitRateOfFreightChangeR(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate of Freight R`}
            prefix={<RupeesSign />}
            //value={record.total_unit_rate_of_freight_R} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
            value={calculateTotalUnitRateOfFreightR(record)}
          // Add onChange handler if needed
          />
        </div>
      </>
    );
  };
  const calculateTotalUnitRateOfFreightR = (record) => {
    const totalUnitRateOfFreightR = state?.bid_rfq_vendor_detail[
      record?.key
    ]?.bid_rfq_detail?.reduce(
      (total, site) =>
        total + (parseFloat(site?.final_bid_price_unit_rate_of_freight) || 0),
      0
    );
    let totalUnitRate = totalUnitRateOfFreightR;
    state.bid_rfq_vendor_detail[record.key].total_of_freight_R = totalUnitRate;

    return totalUnitRateOfFreightR;
  };

  // const renderUnitRateOfTotalUnitRateR = (siteLocations, record) => {
  //   return (
  //     <>
  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //         {siteLocations.map((site, index) => (
  //           <Input
  //             key={index}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             placeholder={`Enter Total Unit Rate for ${site.name}`}
  //             value={record.total_unit_rate}
  //           // Add onChange handler if needed
  //           />
  //         ))}
  //       </div>
  //       <Input
  //         placeholder={`Total Unit Rate R`}
  //         value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
  //         style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //         disabled
  //       // Add onChange handler if needed
  //       />
  //     </>
  //   )
  // }

  // const renderUnitRateOfTotalUnitRateR = (siteLocations, record) => {
  //   return (
  //     <>

  //       <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

  //         {siteLocations.map((site, siteIndex) => (
  //           <Input
  //             key={site.name + siteIndex}
  //             // disabled={enableInputsR1}
  //             style={{ marginRight: '10px', width: '300px' }}
  //             placeholder={`Enter Total Unit Rate for ${site.name}`}
  //             value={state.bid_rfq_vendor_detail[record.key].bid_rfq_detail.final_bid_price_total_unit_rate} // Assuming only one vendor and one site
  //             onChange={(e) => handleTotalUnitRateOfRChange(e.target.value, record.key, siteIndex)}
  //             type="number"
  //           />
  //         ))}
  //       </div>

  //       <Input
  //         placeholder={`Total Unit Rate R0 `}
  //         value={record.total_unit_rate_of_R} // Assuming unit_rate_of_cement is a property in the record
  //         style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //         disabled
  //       // Add onChange handler if needed
  //       />
  //     </>
  //   )
  // }
  const renderUnitRateOfTotalUnitRateR = (siteLocations, record) => {
    return (
      <>
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              // disabled={enableInputsR1}
              style={{  width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              //value={state.bid_rfq_vendor_detail[record.key].bid_rfq_detail.final_bid_price_total_unit_rate} // Assuming only one vendor and one site
              // onChange={(e) => handleTotalUnitRateOfRChange(e.target.value, record.key, siteIndex)}
              // value={
              //   parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate) && parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate_of_freight) ?
              //     (
              //       parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate) +
              //       parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate_of_freight)
              //     ).toFixed(2) // If both initial_bid_price_unit_rate and initial_bid_price_unit_rate_of_freight exist, display their total
              //     :
              //     (parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate) ?
              //       (
              //         parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate)).toFixed(2) // If only initial_bid_price_unit_rate exists, display it
              //       :
              //       (

              //         parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[siteIndex].final_bid_price_unit_rate_of_freight)
              //       ).toFixed(2) // If only initial_bid_price_unit_rate_of_freight exists, display it
              //     )}
              value={
                parseFloat(
                  state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                    siteIndex
                  ].final_bid_price_unit_rate
                ) &&
                  parseFloat(
                    state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                      siteIndex
                    ].final_bid_price_unit_rate_of_freight
                  )
                  ? (
                    parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].final_bid_price_unit_rate
                    ) +
                    parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].final_bid_price_unit_rate_of_freight
                    )
                  ).toFixed(2) // If both initial_bid_price_unit_rate and initial_bid_price_unit_rate_of_freight exist, display their total
                  : parseFloat(
                    state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                      siteIndex
                    ].final_bid_price_unit_rate
                  )
                    ? parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].final_bid_price_unit_rate
                    ).toFixed(2) // If only initial_bid_price_unit_rate exists, display it
                    : parseFloat(
                      state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                        siteIndex
                      ].final_bid_price_unit_rate_of_freight
                    ).toFixed(2) // If only initial_bid_price_unit_rate_of_freight exists, display it
              }
              //onChange={(e) => handleTotalUnitRateOfRChange(e.target.value, record.key, siteIndex)}
              type="number"
            />
          ))}
        </div> */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => {
            const unitRate =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].final_bid_price_unit_rate
              ) || 0;
            const unitRateOfFreight =
              parseFloat(
                state.bid_rfq_vendor_detail[record.key].bid_rfq_detail[
                  siteIndex
                ].final_bid_price_unit_rate_of_freight
              ) || 0;
            const totalUnitRate = unitRate + unitRateOfFreight;

            return (
              <Input
                key={site.name + siteIndex}
                disabled={enableInputs}
                prefix={<RupeesSign />}
                style={{ width: "140px" }}
                placeholder={`Enter Total Unit Rate for ${site.name}`}
                value={totalUnitRate.toFixed(2)} // Display the total unit rate with 2 decimal places
                // onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
                type="number"
              />
            );
          })}
        </div>
        <div className="lbllightred">
          <Input
            placeholder={`Total Unit Rate of R`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfR(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "140px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };
  // const calculateTotalUnitRateOfR = (record) => {
  //   const totalUnitRateOfR = state?.bid_rfq_vendor_detail[record?.key]?.bid_rfq_detail?.reduce(
  //     (total, site) => total + (parseFloat(site?.final_bid_price_total_unit_rate) || 0),
  //     0
  //   );
  //   let totalUnitRate = totalUnitRateOfR;
  //   state.bid_rfq_vendor_detail[record.key].total_unit_rate_of_R = totalUnitRate;

  //   return totalUnitRateOfR;
  // };
  const calculateTotalUnitRateOfR = (record) => {
    const totalUnitRateOfCementR =
      parseFloat(calculateTotalUnitRateOfCementR(record)) || 0;
    const totalUnitRateOfFreightR =
      parseFloat(calculateTotalUnitRateOfFreightR(record)) || 0;

    // Return the sum of the two totals
    return (totalUnitRateOfCementR + totalUnitRateOfFreightR).toFixed(2);
  };

  const handleTotalUnitRateOfRChange = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                return {
                  ...site,
                  final_bid_price_total_unit_rate: value, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };
  // const handleDatePickerChangeCementR0 = (value, vendorIndex, siteIndex) => {
  //   const currentDate = new Date().toISOString().split('T')[0];
  //   console.log(currentDate, "dateeeeee")
  //   setState((prevState) => {
  //     return {
  //       ...prevState,
  //       bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
  //         (vendor, idx) => {
  //           if (idx !== vendorIndex) {
  //             return vendor; // If this vendor is not the one being updated, return it unchanged
  //           }
  //           return {
  //             ...vendor,
  //             bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
  //               if (sIdx !== siteIndex) {
  //                 return site; // If this site is not the one being updated, return it unchanged
  //               }
  //               return {
  //                 ...site,
  //                 initial_bid_price_date: value, // Update the initial_bid_price_unit_rate for this site
  //               };
  //             }),
  //           };
  //         }
  //       ),
  //     };
  //   });
  // };

  const handleDatepickerChangeCementR1 = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                return {
                  ...site,
                  revised_bid_price_date: value, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };
  const handleDatepickerChangeCementR = (value, vendorIndex, siteIndex) => {
    setState((prevState) => {
      return {
        ...prevState,
        bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(
          (vendor, idx) => {
            if (idx !== vendorIndex) {
              return vendor; // If this vendor is not the one being updated, return it unchanged
            }
            return {
              ...vendor,
              bid_rfq_detail: vendor.bid_rfq_detail.map((site, sIdx) => {
                if (sIdx !== siteIndex) {
                  return site; // If this site is not the one being updated, return it unchanged
                }
                return {
                  ...site,
                  final_bid_price_date: value, // Update the initial_bid_price_unit_rate for this site
                };
              }),
            };
          }
        ),
      };
    });
  };
  // const getCurrentDate = () => {
  // Get the day (DD) and pad it with leading zeros if necessary
  // return `${day}-${month}-${year}`; // Return the date in the DD-MM-YYYY format
  // };
  // let currentDate = getCurrentDate();

  // const renderDateR0 = (siteLocations, record, currentDate) => {
  //   console.log(currentDate, "Date Formates")
  //   return (
  //     <>
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "column",
  //           gap: "-0px",
  //           marginBottom: "-30px",
  //         }}
  //       >
  //         {siteLocations.map((site, siteIndex) => (
  //           <Form.Item
  //             name={`initial_bid_price_date_${record.key}_${siteIndex}`}
  //             key={`${record.key}_${siteIndex}`}
  //           >
  //             <Input
  //               // showTime
  //               // format="DD-MM-YYYY"
  //               onChange={(date, dateString) =>
  //                 handleDatePickerChangeCementR0(
  //                   dateString,
  //                   record.key,
  //                   siteIndex
  //                 )
  //               }
  //               style={{  width: "300px" }}
  //              // disabled={isDatePickerDisabled}
  //              value={currentDate}
  //             // disabled
  //               // value={
  //               //   state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
  //               //     siteIndex
  //               //   ]?.initial_bid_price_date
  //               // }

  //             />
  //           </Form.Item>
  //         ))}
  //       </div>
  //     </>
  //   );
  // };
  const renderDateR1 = (siteLocations, record) => {
    return (
      <>
        {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '30px' }}>
          {siteLocations.map((site, index) => (
            <Input
              key={index}
              disabled={enableInputsR1}
              style={{ marginRight: '10px', width: '300px' }}
              placeholder={`Enter Date ${site.name}`}
              value={record.date}
            // Add onChange handler if needed
            />
          ))}
        </div> */}
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "-0px",
              marginBottom: "-30px",
            }}
          >
            {siteLocations.map((site, siteIndex) => (
              <Form.Item
                name={`revised_bid_price_date${record.key}_${siteIndex}`}
                key={`${record.key}_${siteIndex}`}
              >
                <DatePicker
                  showTime
                  format="DD-MM-YYYY"
                  disabled={isDatePickerDisabledR1}
                  onChange={(date, dateString) =>
                    handleDatepickerChangeCementR1(
                      dateString,
                      record.key,
                      siteIndex
                    )
                  }
                  style={{ width: "300px" }}
                  value={
                    state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                      siteIndex
                    ]?.revised_bid_price_date
                  }
                />
              </Form.Item>
            ))}
          </div>
        </>
      </>
    );
  };
  const renderDateR = (siteLocations, record) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "-0px",
            marginBottom: "-30px",
          }}
        >
          {siteLocations.map((site, siteIndex) => (
            <Form.Item
              name={`final_bid_price_date${record.key}_${siteIndex}`}
              key={`${record.key}_${siteIndex}`}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY"
                onChange={(date, dateString) =>
                  handleDatepickerChangeCementR(
                    dateString,
                    record.key,
                    siteIndex
                  )
                }
                style={{ width: "300px" }}
                value={
                  state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
                    siteIndex
                  ]?.final_bid_price_date
                }
              />
            </Form.Item>
          ))}
        </div>
      </>
    );
  };

  const filteredData = vendorBidRFQ2.filter(
    (item) => item.siteLocations && item.siteLocations.length > 0
  );

  // const columns2 = [
  //   {
  //     title: 'Sites',
  //     dataIndex: 'siteLocations',
  //     render: (siteLocations, record, index) => {
  //       if (index === 0 && siteLocations && siteLocations.length > 0) {
  //         return (
  //           <>
  //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //               {siteLocations.map((site, idx) => (
  //                 <div key={idx} readOnly>{site.name}</div>
  //               ))}
  //             </div>
  //             <div style={{ display: 'flex', flexDirection: 'column' }}>
  //               <Input
  //                 placeholder={`Total `}
  //                 value={record.total} // Assuming unit_rate_of_cement is a property in the record
  //                 style={{ width: '200px', top: '20px' }} // Adjust width as needed
  //                 disabled
  //               // Add onChange handler if needed
  //               />
  //             </div>
  //           </>
  //         );
  //       } else {
  //         return null; // Render nothing for other arrays or when siteLocations is null or empty
  //       }
  //     }
  //   },
  //   {
  //     title: 'Amount Without GST',
  //     dataIndex: 'siteLocations',
  //     render: (siteLocations, record, index) => {
  //       if (index === 0 && siteLocations && siteLocations.length > 0) {
  //         return (
  //           <>
  //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //               {siteLocations.map((site, idx) => (
  //                 <Input
  //                   key={idx}
  //                   style={{ width: '300px' }}
  //                   prefix={<RupeesSign />}
  //                   value={site.amount_without_gst || ''} // Assuming `amount_without_gst` is available in site object
  //                   placeholder={`Enter Amount Without GST for ${site.name}`}
  //                 />
  //               ))}
  //             </div>
  //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //               <Input
  //                 placeholder={`Total `}
  //                 prefix={<RupeesSign />}
  //                 value={record.total} // Assuming unit_rate_of_cement is a property in the record
  //                 style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //                 disabled
  //               // Add onChange handler if needed
  //               />
  //             </div>
  //           </>

  //         );
  //       } else {
  //         return null;
  //       }
  //     }
  //   },
  //   {
  //     title: 'Amount With GST',
  //     dataIndex: 'siteLocations',
  //     render: (siteLocations, record, index) => {
  //       if (index === 0 && siteLocations && siteLocations.length > 0) {
  //         return (
  //           <>
  //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //               {siteLocations.map((site, idx) => (
  //                 <Input
  //                   key={idx}
  //                   style={{ width: '300px' }}
  //                   prefix={<RupeesSign />}
  //                   placeholder={`Enter Amount With GST for ${site.name}`}
  //                 //value={record.amount_without_gst}
  //                 />
  //               ))}
  //             </div>
  //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  //               <Input
  //                 placeholder={`Total `}
  //                 prefix={<RupeesSign />}
  //                 value={record.total} // Assuming unit_rate_of_cement is a property in the record
  //                 style={{ width: '300px', top: '10px' }} // Adjust width as needed
  //                 disabled
  //               // Add onChange handler if needed
  //               />
  //             </div>
  //           </>
  //         );
  //       } else {
  //         return null;
  //       }
  //     }
  //   }
  // ];

  const columns2 = [
    {
      title: "Sites",
      dataIndex: "siteLocations",
      render: (siteLocations, record) => (
        // <div
        //   className="footertblsite"
        //   style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        // >
        //   {siteLocations.map((site, idx) => (
        //     <div key={idx} readOnly>
        //       {site.name}
        //     </div>
        //   ))}
        // </div>
        <>
          <div
            className="footertblsite"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, idx) => (
              <div key={idx} readOnly>
                {site.name}
              </div>
            ))}
          </div>
          <div
            className="footertblsite"
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Input
              placeholder={`Total`}
              value={record.total} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: "200px", top: "10px" }} // Adjust width as needed
              disabled
            />
          </div>
        </>
      ),
    },
    {
      title: "Amount Without GST",
      dataIndex: "siteLocations",
      // render: (siteLocations, record) => (
      //   <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      //     {siteLocations.map((site, idx) => {
      //       const siteId = site.id;
      //       const poValue = siteWithoutGstRates[siteId];
      //       return (
      //         <Input
      //           key={idx}
      //           style={{ width: "170px" }}
      //           prefix={<RupeesSign />}
      //           // value={site.amount_without_gst || ''}
      //           value={poValue !== undefined ? poValue : ""}
      //           placeholder={`Enter Amount Without GST for ${site.name}`}
      //         />
      //       );
      //     })}
      //   </div>
      // ),
      render: (siteLocations, record) => {
        let totalWithoutGst = 0;

        return (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, idx) => {
              const siteId = site.id;
              const poValue = siteWithoutGstRates[siteId];

              if (poValue !== undefined) {
                totalWithoutGst += parseFloat(poValue);
              }

              return (
                <Input
                  key={idx}
                  disabled
                  style={{ width: "150px" }}
                  prefix={<RupeesSign />}
                  value={poValue !== undefined ? poValue : ""}
                  placeholder={`Enter Amount Without GST for ${site.name}`}
                />
              );
            })}
            <div className="lbllightred">
              <Input
                style={{ width: "150px" }}
                prefix={<RupeesSign />}
                value={totalWithoutGst}
                disabled
                placeholder={`Total Amount without gst`}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Amount With GST",
      dataIndex: "siteLocations",
      // render: (siteLocations, record) => (
      //   <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      //     {siteLocations.map((site, idx) => {
      //       const siteId = site.id;
      //       const poValue = siteGstRates[siteId]; // Retrieve PO value for the current site ID

      //       return (
      //         <Input
      //           key={idx}
      //           style={{ width: "170px" }}
      //           prefix={<RupeesSign />}
      //           value={poValue !== undefined ? poValue : ""} // Display PO value if available, otherwise display empty string
      //           placeholder={`Enter Amount With GST for ${site.name}`}
      //         />
      //       );
      //     })}
      //   </div>
      // ),
      render: (siteLocations, record) => {
        let totalWithGst = 0;

        return (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, idx) => {
              const siteId = site.id;
              const poValue = siteGstRates[siteId]; // Retrieve PO value for the current site ID

              if (poValue !== undefined) {
                totalWithGst += parseFloat(poValue);
              }

              return (
                <Input
                  key={idx}
                  disabled
                  style={{ width: "150px" }}
                  prefix={<RupeesSign />}
                  value={poValue !== undefined ? poValue : ""}
                  placeholder={`Enter Amount With GST for ${site.name}`}
                />
              );
            })}
            <div className="lbllightred">
              <Input
                style={{ width: "150px" }}
                prefix={<RupeesSign />}
                value={totalWithGst}
                placeholder={`Total Amount With GST`}
                disabled
              />
            </div>
          </div>
        );
      },
    },
  ];

  const toggleUnitRateCementR1 = () => {
    setShowUnitRateCementR1(!showUnitRateCementR1);
  };

  const toggleUnitRateCementR = () => {
    setShowUnitRateCementR(!showUnitRateCementR);
  };
  const [enableInputs, setEnableInputs] = useState(false);
  const [enableInputsR1, setEnableInputsR1] = useState(false);
  const [firstClick, setFirstClick] = useState(true);

  // const resetGSTValues = () => {
  //   // Reset GST related state values
  //   const resetState = state.bid_rfq_vendor_detail.map(vendor => ({
  //     ...vendor,
  //     bid_rfq_detail: vendor.bid_rfq_detail.map(site => ({
  //       ...site,
  //       gst_inclusive_unit_rate: null,
  //       amount_without_gst: null,
  //       amount_with_gst: null
  //     }))
  //   }));
  //   setState(prevState => ({
  //     ...prevState,
  //     bid_rfq_vendor_detail: resetState
  //   }));
  // };

  // const resetGSTValues = () => {

  //   setState(prevState => ({
  //     ...prevState,
  //     bid_rfq_vendor_detail: prevState.bid_rfq_vendor_detail.map(vendor => ({
  //       ...vendor,
  //       bid_rfq_site_detail: vendor.bid_rfq_site_detail.map(site => ({
  //         ...site,
  //         amount_with_gst: null,
  //         gst_inclusive_unit_rate: null,
  //         amount_without_gst: null,
  //         totalAmountWithoutGST: null,
  //         // amount_with_gst: null
  //       }))
  //     }))
  //   }));
  // };

  const resetGSTValues = () => {
    const resetState = {
      ...state,
      bid_rfq_vendor_detail: state.bid_rfq_vendor_detail.map((detail) => ({
        ...detail,
        bid_rfq_detail: detail.bid_rfq_detail.map((siteDetail) => {
          // let updatedSiteDetail = { ...siteDetail };
          // console.log("updatedSiteDetail 1", updatedSiteDetail);
          // console.log("amountWithGst", updatedSiteDetail.amount_with_gst);

          // Deep clone the object to ensure immutability
          // updatedSiteDetail = JSON.parse(JSON.stringify(updatedSiteDetail));

          // updatedSiteDetail.gst_inclusive_unit_rate = null;
          // updatedSiteDetail.amount_without_gst = null;
          // updatedSiteDetail.amount_with_gst = null;
          // console.log("updatedSiteDetail 2 ", updatedSiteDetail);
          // console.log(
          //   "amountWithGstAfterUpdate",
          //   updatedSiteDetail.amount_with_gst
          // );
          return {
            ...siteDetail,
            gst_inclusive_unit_rate: null,
            amount_without_gst: null,
            amount_with_gst: null,
          };
        }),
      })),
    };
    setState(resetState);
  };

  // const resetGSTValues = () => {
  //   // Reset GST related state values
  //   const resetState = state.bid_rfq_vendor_detail.map(vendor => ({
  //     ...vendor,
  //     bid_rfq_site_detail: vendor.bid_rfq_site_detail.map(site => ({
  //       ...site,
  //       gst_inclusive_unit_rate: null,
  //       amount_without_gst: null,
  //       amount_with_gst: null

  //     }))
  //   }));

  //   setState(prevState => ({
  //     ...prevState,
  //     bid_rfq_vendor_detail: resetState
  //   }));
  // };
  // const handleNavigateToHistory = () => {
  //   console.log("tracking of stages", trackingOfStages);
  //   if (trackingOfStages === 2) {
  //     console.log("Inside if track===3");
  //     navigate(`/vendor-request-for-quotation/history/${CategoryId}`);
  //   }
  // };
  const handleBidSubmission = () => {
    // Toggle the state for showing Unit Rate of Cement R1 based on isFinalBidPrice
    setShowUnitRateCementR1(!isFinalBidPrice);
    setShowUnitRateCementR(!isFinalBidPrice && !firstClick);
    // Toggle the state for showing Unit Rate of Cement R based on isFinalBidPrice
    //setShowUnitRateCementR(!isFinalBidPrice && !firstClick);
    if (!isFinalBidPrice && !firstClick) {
      setEnableInputsR1(true);
      resetGSTValues();
      setIsDatePickerDisabledR1(true);
    }

    if (!isFinalBidPrice) {
      setEnableInputs(true);
      resetGSTValues();
      setGstInitialValue(true);
      setShowAdditionalCheckboxes(true);
      setShowAdditionalCheckboxesFinal(false);
    } else {
      setShowAdditionalCheckboxes(false);
      setEnableInputs(false);
      // navigate(`/vendor-request-for-quotation/history/${CategoryId}`);
    }
    setFirstClick(false);
    setIsDatePickerDisabled(true);
    // let totalAmountWithoutGST = 0;

    // state.bid_rfq_vendor_detail.forEach(vendor => {
    //   vendor.bid_rfq_site_detail.forEach(site => {
    //     totalAmountWithoutGST += parseFloat(site.amount_without_gst) || 0;
    //   });
    // });

    // // Update the state with the total amount without GST
    // setState(prevState => ({
    //   ...prevState,
    //   amount_without_gst: totalAmountWithoutGST.toFixed(2)
    // }));
    if (trackingOfStages === 0) {
      setIsSubmitClicked(true);
      handleSubmit();
    } else if (trackingOfStages === 1) {
      handleSubmitPatch();
      setIsSubmitClicked2(true);
      resetGSTValues();
    } else {
      handleSubmitPatch();
      setIsSubmitClicked3(true);
      resetGSTValues();
    }
    // handleNavigateToHistory();
  };

  // const handleBidSubmission = () => {
  //   setShowUnitRateCementR1(!isFinalBidPrice);
  //   setShowUnitRateCementR(!isFinalBidPrice && !firstClick);

  //   if (!isFinalBidPrice && !firstClick) {
  //     setEnableInputsR1(true);
  //     resetGSTValues();
  //     setIsDatePickerDisabledR1(true);
  //   }

  //   if (!isFinalBidPrice) {
  //     setEnableInputs(true);
  //     resetGSTValues();
  //     setShowAdditionalCheckboxes(true);
  //     setShowAdditionalCheckboxesFinal(false);
  //   } else {
  //     setShowAdditionalCheckboxes(false);
  //     setEnableInputs(false);
  //     // navigate(`/vendor-request-for-quotation/history/${CategoryId}`);
  //   }

  //   setFirstClick(false);
  //   setIsDatePickerDisabled(true);

  //   const updatedVendors = state.bid_rfq_vendor_detail.map(vendor => {
  //     let vendorTotal = 0;
  //     const updatedSites = vendor.bid_rfq_site_detail.map(site => {
  //       const siteAmount = parseFloat(site.amount_without_gst);
  //       if (!isNaN(siteAmount)) {
  //         vendorTotal += siteAmount;
  //       } else {
  //         site.amount_without_gst = "0.00";
  //       }
  //       return { ...site, amount_without_gst: siteAmount.toFixed(2) };
  //     });

  //     if (isNaN(vendorTotal)) {
  //       vendorTotal = 0;
  //     }

  //     return { ...vendor, bid_rfq_site_detail: updatedSites, totalAmountWithoutGST: vendorTotal.toFixed(2) };
  //   });

  //   const overallTotalAmountWithoutGST = updatedVendors.reduce((acc, vendor) => {
  //     return acc + parseFloat(vendor.totalAmountWithoutGST);
  //   }, 0);

  //     bid_rfq_vendor_detail: updatedVendors,
  //     amount_without_gst: overallTotalAmountWithoutGST.toFixed(2)
  //   });

  //   setState(prevState => ({
  //     ...prevState,
  //     bid_rfq_vendor_detail: updatedVendors,
  //     amount_without_gst: overallTotalAmountWithoutGST.toFixed(2)
  //   }));
  // };

  // const [hideUnitRateOfCement, setHideUnitRateOfCement] = useState(true);
  // const [hideUnitRateOfFreight, setHideUnitRateOfFreight] = useState(true);
  // const [buying_patterna, setBuyingPatterna] = useState("Unit Rate of Cement");

  // Effect hook to update column visibility based on `buying_patterna`
  // const renderAmountWithGSTR0 = (siteLocations, record) => {
  //   let totalGST = 0;

  //   // Iterate over each site in siteLocations
  //   siteLocations.forEach((site, siteIndex) => {
  //     // Get the unit rate and unit rate of freight for the current site
  //     const unitRate = parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate) || 0;
  //     const unitRateOfFreight = parseFloat(state.bid_rfq_vendor_detail[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate_of_freight) || 0;
  //     const quantity = parseFloat(site.quantity) || 0;

  //     // Calculate the total unit rate for the current site
  //     const totalUnitRate = (unitRate + unitRateOfFreight) * quantity;

  //     // Get the GST rate for the vendor
  //     const gstRate = parseFloat(state.bid_rfq_vendor_detail[record.key].gst_rate) || 0;

  //     // Calculate the GST amount for the current site
  //     const gstAmount = (totalUnitRate * gstRate) / 100 ;

  //     const TotalGSTR0 = gstAmount + (unitRate + unitRateOfFreight);

  //     // Add the GST amount to the total GST
  //     totalGST += TotalGSTR0;
  //   });

  //   // Return the total GST rounded to 2 decimal places
  //   return totalGST.toFixed(2);
  // };

  const calculateAmountWithGSTR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    // Return the sum of the two totals
    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(2);
  };
  const [showDatePickers, setShowDatePickers] = useState(false);
  const [hideInitialBIDPriceCementR0, setHideInitialBIDPriceCementR0] =
    useState(false);
  const [hideInitialBIDPriceFreightR0, setHideInitialBIDPriceFreightR0] =
    useState(false);
  const [hideInitialBIDPriceTotalR0, setHideInitialBIDPriceTotalR0] =
    useState(false);
  const [hiddenDatepickerData, sethiddenDatepicker] = useState(false);
  const [hideInitialBIDPriceCementR1, setHideInitialBIDPriceCementR1] =
    useState(false);
  const [hideInitialBIDPriceFreightR1, setHideInitialBIDPriceFreightR1] =
    useState(false);
  const [hideInitialBIDPriceTotalRateR1, setHideInitialBIDPriceTotalRateR1] =
    useState(false);
  const [hideInitialBIDPriceDateR1, setHideInitialBIDPriceDateR1] =
    useState(false);
  // Function to toggle visibility of "Initial BID Price - R0" column
  const toggleHideInitialBIDPriceR0 = () => {
    setHideInitialBIDPriceCementR0(!hideInitialBIDPriceCementR0);
    setHideInitialBIDPriceFreightR0(!hideInitialBIDPriceFreightR0);
    setHideInitialBIDPriceTotalR0(!hideInitialBIDPriceTotalR0);
    sethiddenDatepicker(!hiddenDatepickerData);
    if (
      !hideInitialBIDPriceCementR0 &&
      !hideInitialBIDPriceFreightR0 &&
      !hideInitialBIDPriceTotalR0
    ) {
      resetGSTValues();
    }
  };

  const toggleHideInitialBIDPriceR1 = () => {
    setHideInitialBIDPriceCementR1(!hideInitialBIDPriceCementR1);
    setHideInitialBIDPriceFreightR1(!hideInitialBIDPriceFreightR1);
    setHideInitialBIDPriceTotalRateR1(!hideInitialBIDPriceTotalRateR1);
    setHideInitialBIDPriceDateR1(!hideInitialBIDPriceDateR1);
    // Call resetGSTValues() if all checkboxes are unchecked
    if (
      !hideInitialBIDPriceCementR1 &&
      !hideInitialBIDPriceFreightR1 &&
      !hideInitialBIDPriceTotalRateR1 &&
      !hideInitialBIDPriceDateR1
    ) {
      resetGSTValues();
    }
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      //render: (text, record, index) => index + 1,
      render: (text, record, index) => <div className="lblvalue">{index + 1}</div>,
      width: 150,
    },
    {
      title: "Item Name",
      dataIndex: "rfq_material_type_name",
      key: "rfq_material_type_name",
      render: (text, record, index) => (
        <div className="lblvalue highligh">{record?.rfq_material_type_name}</div>
      ),
    },
    {
      title: "Site Location",
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div className="lblvalue" key={index} readOnly>
                {site.name}
              </div>
            ))}
          </div>
        </>
      ),
      // hidden: hiddenColumns.includes('siteLocation')
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div className="lblvalue" key={index} readOnly>
                {site.quantity}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "UOM",
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div className="lblvalue" key={index} disabled>
                {site.uom}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: 'R0',
      hidden:
      hideInitialBIDPriceCementR0 ||
      !(
        buyingPattern === "Unit Rate of Cement" ||
        buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
        buyingPattern === "Total Unit Rate"
      ),
      children: [
    {
      title: "Unit Rate of Cement",
      dataIndex: "siteLocations",
      hidden:
        hideInitialBIDPriceCementR0 ||
        !(
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      // hidden: hideInitialBIDPriceCementR0,
      render: (siteLocations, record) =>
        renderUnitRateOfCementR0(siteLocations, record),
    },
    {
      title: "Unit Rate of Freight",
      dataIndex: "siteLocations",
      // hidden: hideInitialBIDPriceFreightR0,
      hidden:
        hideInitialBIDPriceFreightR0 ||
        !(
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      render: (siteLocations, record) =>
        renderUnitRateOfFreightR0(siteLocations, record),
    },
    {
      title: "Total Unit Rate",
      dataIndex: "siteLocations",
      hidden:
        hideInitialBIDPriceTotalR0 ||
        !(
          buyingPattern === "Total Unit Rate" ||
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight"
        ),
      render: (siteLocations, record) =>
        renderUnitRateOfTotalUnitRateR0(siteLocations, record),
      //   return renderUnitRateOfTotalUnitRateR0(siteLocations, record); // Otherwise, render the column content
    },
    // {
    //   title: "Date",
    //   dataIndex: "siteLocations",
    //   hidden: hiddenDatepickerData,
    //   //  hidden: hideUnitRateOfCementR0,
    //   //hidden: hideUnitRateOfCementR0,
    //   render: (siteLocations, record) => renderDateR0(siteLocations, record, currentDate),
    //   //return renderDateR0(siteLocations, record); // Otherwise, render the column content

    // },
    // {
    //   title: "Date",
    //   dataIndex: "siteLocations",
    //   //hidden: hiddenDatepickerData,
    //   render: (siteLocations) => (
    //     <>
    //      {siteLocations.map((site, index) => (
    //         <div key={index} disabled      style={{ width: "200px", top: "10px"}}>
    //             <Input key={index} type="text" value={currentDate} disabled />
    //         </div>
    //       ))}

    //     </>
    //   ),
    // },
  ]
},
    {
      title: "Date",
      dataIndex: "siteLocations",
      // hidden: hiddenDatepickerData,
      hidden:
        !showUnitRateCementR1 ||
        hideInitialBIDPriceDateR1 ||
        hiddenDatepickerData,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} style={{ width: "150px" }}>
                {/* Check if the submit button has been clicked */}
                {isSubmitClicked ? (
                  <Input type="text" value={currentDate} disabled />
                ) : (
                  <Input type="text" value="" disabled />
                )}
              </div>
            ))}
          </div>
        </>
      ),
    },
{
  title: 'R1',
  hidden:
  !showUnitRateCementR1 ||
  hideInitialBIDPriceCementR1 ||
  !(
    buyingPattern === "Unit Rate of Cement" ||
    buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
    buyingPattern === "Total Unit Rate"
  ),
  children: [
    {
      title: "Unit Rate of Cement",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR1 ||
        hideInitialBIDPriceCementR1 ||
        !(
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      render: (siteLocations, record) =>
        renderUnitRateOfCementR1(siteLocations, record),
    },
    {
      title: "Unit Rate of Freight",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR1 ||
        hideInitialBIDPriceFreightR1 ||
        !(
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      render: (siteLocations, record) =>
        renderUnitRateOfFreightR1(siteLocations, record),
    },
    {
      title: "Total Unit Rate",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR1 ||
        hideInitialBIDPriceTotalRateR1 ||
        !(
          buyingPattern === "Total Unit Rate" ||
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight"
        ),
      render: (siteLocations, record) =>
        renderUnitRateOfTotalUnitRateR1(siteLocations, record),
    },
  ]
},
    // {
    //   title: "Date",
    //   dataIndex: "siteLocations",
    //   hidden: !showUnitRateCementR1 || hideInitialBIDPriceDateR1,
    //   render: (siteLocations, record) => renderDateR1(siteLocations, record),
    // },
    {
      title: "Date",
      dataIndex: "siteLocations",
      // hidden: !showUnitRateCementR1 || hideInitialBIDPriceDateR1,
      hidden:
        !showUnitRateCementR ||
        !showUnitRateCementR1 ||
        hideInitialBIDPriceDateR1,
      render: (siteLocations) => (
        <>
          {siteLocations.map((site, index) => (
            <div key={index} style={{ width: "140px", top: "10px" }}>
              {/* Check if the submit button has been clicked */}
              {isSubmitClicked2 ? (
                <Input key={index} type="text" value={currentDate} disabled />
              ) : (
                <Input key={index} type="text" value="" disabled />
              )}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'R',
       hidden:
        !showUnitRateCementR ||
        !(
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      children: [
    {
      title: "Unit Rate of Cement",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR ||
        !(
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      render: (siteLocations, record) => {
        return renderUnitRateOfCementR(siteLocations, record); // Otherwise, render the column content
      },
    },
    {
      title: "Unit Rate of Freight",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR ||
        !(
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight" ||
          buyingPattern === "Total Unit Rate"
        ),
      render: (siteLocations, record) => {
        return renderUnitRateOfFreightR(siteLocations, record); // Otherwise, render the column content
      },
    },
    {
      title: "Total Unit Rate",
      dataIndex: "siteLocations",
      hidden:
        !showUnitRateCementR ||
        !(
          buyingPattern === "Total Unit Rate" ||
          buyingPattern === "Unit Rate of Cement" ||
          buyingPattern === "Unit Rate of Cement & Unit Rate of Freight"
        ),
      render: (siteLocations, record) => {
        return renderUnitRateOfTotalUnitRateR(siteLocations, record); // Otherwise, render the column content
      },
    },
  ]
},
    // {
    //   title: "Date",
    //   dataIndex: "siteLocations",
    //   //  hidden: hideUnitRateOfCementR0,
    //   hidden: !showUnitRateCementR,
    //   render: (siteLocations, record) => {
    //     return renderDateR(siteLocations, record); // Otherwise, render the column content
    //   },
    // },
    // {
    //   title: "Date",
    //   dataIndex: "siteLocations",
    //   hidden: !showUnitRateCementR,
    //   render: (siteLocations) => (
    //     <>
    //       {siteLocations.map((site, index) => (
    //         <div key={index} style={{ width: "140px", top: "10px" }}>
    //           {/* Check if the submit button has been clicked */}
    //           {isSubmitClicked3 ? (
    //             <Input key={index} type="text" value={currentDate} disabled />
    //           ) : (
    //             <Input key={index} type="text" value="" disabled />
    //           )}
    //         </div>
    //       ))}
    //     </>
    //   ),
    // },
    {
      title: "Unit Rate With GST",
      dataIndex: "siteLocations",

      render: (siteLocations, record, indexAll) => {
        let totalGstInclusiveUnitRate = 0;

        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {
                // Assuming each `vendorDetail` contains a `bid_rfq_site_detail` array you want to iterate over

                siteLocations.map((site, index) => {
                  // Directly use `site` to access its `gst_inclusive_unit_rate`
                  const quantity = parseFloat(site.quantity) || 0;
                  let firstUnitRate;
                  if (trackingOfStages === 0) {
                    firstUnitRate =
                      parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].initial_bid_price_unit_rate
                      ) || 0;
                  }
                  if (trackingOfStages === 1) {
                    firstUnitRate =
                      parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].revised_bid_price_unit_rate
                      ) || 0;
                  }
                  if (trackingOfStages === 2) {
                    firstUnitRate =
                      parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].final_bid_price_unit_rate
                      ) || 0;
                  }
                  let gstInclusiveUnitRate =
                    firstUnitRate * quantity * (gstRate / 100);
                  // const gstInclusiveUnitRate =
                  //   state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[index]
                  //     .gst_inclusive_unit_rate; // Access it directly from `site`
                  totalGstInclusiveUnitRate += gstInclusiveUnitRate || 0;

                  if (!gstInitialValue) {
                    gstInclusiveUnitRate = state.bid_rfq_vendor_detail[
                      indexAll
                    ].bid_rfq_detail[index].gst_inclusive_unit_rate =
                      gstInclusiveUnitRate;
                  } else {
                    // setGstInitialValue((gstInitialValue) => gstInitialValue=false);

                    gstInclusiveUnitRate = state.bid_rfq_vendor_detail[
                      indexAll
                    ].bid_rfq_detail[index].gst_inclusive_unit_rate = 0; // Set amount_without_gst for each site detail
                  }

                  return (
                    <Input
                      key={site.id} // Assuming each site has a unique `id`
                      prefix={<RupeesSign />}
                      disabled
                      value={
                        !gstInitialValue
                          ? gstInclusiveUnitRate
                            ? gstInclusiveUnitRate.toFixed(2)
                            : ""
                          : 0
                      } // Display gst_inclusive_unit_rate if it's defined
                      style={{ width: "140px" }}
                    />
                  );
                })
              }
            </div>
            <div className="lbllightred">
              <Input
                placeholder={`Total Unit Rate with GST `}
                prefix={<RupeesSign />}
                value={totalGstInclusiveUnitRate.toFixed(2)} // Assuming unit_rate_of_cement is a property in the record
                style={{ width: "140px", top: "10px" }} // Adjust width as needed
                disabled
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Amount Without GST",
      dataIndex: "siteLocations",
      render: (siteLocations, record, indexAll) => {
        let totalAmount = 0;
        let totalGrand = 0;
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                let unitRate;
                let unitRateOfFreight;
                if (trackingOfStages === 0) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].initial_bid_price_unit_rate
                    ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].initial_bid_price_unit_rate_of_freight
                    ) || 0;
                }
                if (trackingOfStages === 1) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].revised_bid_price_unit_rate
                    ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].revised_bid_price_unit_rate_of_freight
                    ) || 0;
                }
                if (trackingOfStages === 2) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].final_bid_price_unit_rate
                    ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].final_bid_price_unit_rate_of_freight
                    ) || 0;
                }
                const quantity = parseFloat(site.quantity) || 0;
                const totalUnitRate = (unitRate + unitRateOfFreight) * quantity;
                // let grandtotalUnitRate = totalUnitRate;
                let grandtotalUnitRate;
                if (!gstInitialValue) {
                  // console.log(b)

                  grandtotalUnitRate =
                    state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                      index
                    ].amount_without_gst =
                    grandtotalUnitRate =
                    totalUnitRate;
                } else {
                  // setGstInitialValue((gstInitialValue) => gstInitialValue=false);

                  grandtotalUnitRate = state.bid_rfq_vendor_detail[
                    indexAll
                  ].bid_rfq_detail[index].amount_without_gst = 0; // Set amount_without_gst for each site detail
                }
                totalAmount += grandtotalUnitRate || 0;
                record.totalAmount = totalAmount.toFixed(2);

                return (
                  <Input
                    key={site.id}
                    prefix={<RupeesSign />}
                    disabled
                    value={
                      grandtotalUnitRate !== 0
                        ? grandtotalUnitRate.toFixed(2)
                        : 0
                    }
                    // value={
                    //   state?.bid_rfq_vendor_detail[indexAll]
                    //     .bid_rfq_site_detail[index].amount_without_gst !== 0 ||
                    //   state?.bid_rfq_vendor_detail[indexAll]
                    //     .bid_rfq_site_detail[index].amount_without_gst !== null
                    //     ? state?.bid_rfq_vendor_detail[
                    //         indexAll
                    //       ].bid_rfq_site_detail[
                    //         index
                    //       ].amount_without_gst.toFixed(2)
                    //     : ""
                    // }
                    style={{ width: "140px" }}
                  />
                );
              })}
            </div>
            <div className="lbllightred">
              <Input
                placeholder={`Total Unit Rate without GST`}
                prefix={<RupeesSign />}
                value={totalAmount !== 0 ? totalAmount.toFixed(2) : ""}
                style={{ width: "140px", top: "10px" }}
                disabled
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Amount With GST",
      dataIndex: "siteLocations",
      render: (siteLocations, record, indexAll) => {
        let totalGstInclusiveUnitRate = 0;

        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                let totalQty; 
                let unitRate;
                let unitRateOfFreight;
                if (trackingOfStages === 0) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].initial_bid_price_unit_rate
                    ) || 0;
                    totalQty = parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].initial_bid_price_total_unit_rate
                      ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].initial_bid_price_unit_rate_of_freight
                    ) || 0;
                }
                if (trackingOfStages === 1) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].revised_bid_price_unit_rate
                    ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].revised_bid_price_unit_rate_of_freight
                    ) || 0;

                    totalQty = parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].revised_bid_price_total_unit_rate
                      ) || 0;
                }
                if (trackingOfStages === 2) {
                  unitRate =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].final_bid_price_unit_rate
                    ) || 0;
                  unitRateOfFreight =
                    parseFloat(
                      state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                        index
                      ].final_bid_price_unit_rate_of_freight
                    ) || 0;

                    totalQty = parseFloat(
                        state.bid_rfq_vendor_detail[indexAll].bid_rfq_detail[
                          index
                        ].final_bid_price_total_unit_rate
                      ) || 0;
                }

                const quantity = parseFloat(site.quantity) || 0;
                const totalSum = unitRate + unitRateOfFreight;
                const totalUnitRate = totalSum * quantity;
                const gstRate =
                  parseFloat(state.bid_rfq_vendor_detail[indexAll].gst_rate) ||
                  0;
                // const gstInPercent = gstRate / 100;
                const gstAmount = totalUnitRate
                  ? (totalUnitRate * gstRate) / 100 + totalUnitRate
                  : 0;
                let gstInclusiveUnitRateGSt = 0;

                let amountWithGst;
                if (!gstInitialValue) {
                  // !gstInitialValue
                  // ?

                  gstInclusiveUnitRateGSt = gstAmount;
                  amountWithGst = state.bid_rfq_vendor_detail[
                    indexAll
                  ].bid_rfq_detail[index].amount_with_gst =
                    gstInclusiveUnitRateGSt;
                } else {
                  setGstInitialValue(
                    (gstInitialValue) => (gstInitialValue = false)
                  );

                  amountWithGst = state.bid_rfq_vendor_detail[
                    indexAll
                  ].bid_rfq_detail[index].amount_with_gst = 0;
                }
                totalGstInclusiveUnitRate += gstInclusiveUnitRateGSt || 0;
                // detail.amount_with_gst = gstInclusiveUnitRateGSt;
                // const newState = { ...state };
                // newState.bid_rfq_vendor_detail[indexAll].bid_rfq_site_detail[index].amount_with_gst = gstInclusiveUnitRate;
                // setState(newState);
                // return {

                //   ...detail,
                //   amount_with_gst: gstInclusiveUnitRateGSt,
                // };
                return (
                  <Input
                    key={site.id}
                    prefix={<RupeesSign />}
                    disabled
                    value={amountWithGst ? amountWithGst.toFixed(2) : ""}
                    //  value={gstInclusiveUnitRateGSt ? gstInclusiveUnitRateGSt.toFixed(2) : ''}

                    style={{ width: "140px" }}
                  />
                );
              })}
            </div>
            <div className="lbllightred">
              <Input
                placeholder={`Total Amount with GST`}
                prefix={<RupeesSign />}
                //value={totalGstInclusiveUnitRate.toFixed(2)}
                value={
                  totalGstInclusiveUnitRate
                    ? totalGstInclusiveUnitRate.toFixed(2)
                    : ""
                }
                style={{ width: "140px", top: "10px" }}
                disabled
              />
            </div>
          </>
        );
      },

      // render: (siteLocations, record) => (
      //   <>
      //     <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      //       {siteLocations.map((site, index) => (
      //         <Input
      //           key={index}
      //           prefix={<RupeesSign />}
      //           disabled
      //           value={record.amount_with_gst}
      //           style={{ width: '200px' }} // Adjust width as needed
      //         />
      //       ))}
      //     </div>
      //     <Input
      //       placeholder={`Total Amount with GST `}
      //       prefix={<RupeesSign />}
      //       value={record.total_amount_with_gst} // Assuming unit_rate_of_cement is a property in the record
      //       style={{ width: '200px', top: '10px' }} // Adjust width as needed
      //       disabled
      //     />
      //   </>
      // )
    },
    {
      title: "LQP For This Client",
      dataIndex: "siteLocations",
      render: (siteLocations, record) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <Input
                key={index}
                prefix={<RupeesSign />}
                disabled
                value={record.lqp_for_this_client}
                style={{ width: "140px" }} // Adjust width as needed
              />
            ))}
          </div>
          <div className="lbllightred">
            <Input
              placeholder={`Total LQP For This Client `}
              prefix={<RupeesSign />}
              value={record.total_lqp_for_this_client} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: "140px", top: "10px" }} // Adjust width as needed
              disabled
            />
          </div>
        </>
      ),
    },
    {
      title: "LQP For This Any Client",
      dataIndex: "siteLocations",
      render: (siteLocations, record) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <Input
                key={index}
                prefix={<RupeesSign />}
                disabled
                value={record.lqp_for_this_any_client}
                style={{ width: "140px" }} // Adjust width as needed
              />
            ))}
          </div>
          <div className="lbllightred">
            <Input
              placeholder={`Total LQP For This Any Client `}
              prefix={<RupeesSign />}
              value={record.total_lqp_for_this_any_client} // Assuming unit_rate_of_cement is a property in the record
              style={{ width: "140px", top: "10px" }} // Adjust width as needed
              disabled
            />
          </div>
        </>
      ),
    },
  ];

  const handleOptionChange = (option) => {
    const index = selectedOptions.indexOf(option);
    if (index === -1) {
      setSelectedOptions([...selectedOptions, option]);
    } else {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    }
  };

  const onChangeFinalBid = (isChecked, rfqVendorDetailId) => {
    // Update the bidItems state
    const updatedBidItems = state.bid_rfq_vendor_detail.map((item) => {
      if (item.rfq_vendor_detail === rfqVendorDetailId) {
        return { ...item, is_final_bid_price: isChecked };
      }
      return item;
    });

    setState((prevState) => ({
      ...prevState,
      bid_rfq_vendor_detail: updatedBidItems,
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      vendor: VendorId,
      is_final_bid_price: state.is_final_bid_price,
      bid_rfq_vendor_detail: state.bid_rfq_vendor_detail,
    };
    try {
      setLoading(true);
      // setapiLoading(true);
      let response;
      response = await patchRequest(
        `bid-rfq/${vendorBidId}/create-bid-rfq/`,
        payload
      );

      // setPatchId(PatchId);
      if (response.data.success) {
        // const patchId = response.data.data[0].id;
        setLoading(false);

        let responseData = await getRequest(
          `bid-rfq/${vendorBidId}/get-bid-rfq-by-vendor/?vendor_id=${VendorId}`
        );
        console.log(responseData);
        // const newState2 = {
        //   vendor: VendorId,
        //   bid_rfq_vendor_detail: responseData.data.data[0].rfq_site_wise_vendor.
        //   map((item) => ({
        //     rfq_material_type_name: item.rfq_material_type_name,
        //     rfq_material_type: item.rfq_material_type_id,
        //     rfq_site_wise_vendor: item.rfq_site_wise_vendor.map((site) => ({
        //       // company: site.company,
        //       // rfq_number: site.rfq_number,
        //       bid_rfq_detail: site.bid_rfq_detail.map((detail) => ({
        //         // bid_rfq_id: detail.bid_rfq_id,
        //         purchase_requisition_site_id: detail.purchase_requisition_site_id,
        //         purchase_requisition_site_name: detail.purchase_requisition_site_name,
        //         site_wise_total_quantity: detail.site_wise_total_quantity,
        //         initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
        //         initial_bid_price_unit_rate_of_freight: detail.initial_bid_price_unit_rate_of_freight,
        //         initial_bid_price_total_unit_rate: detail.initial_bid_price_total_unit_rate,
        //         initial_bid_price_date: detail.initial_bid_price_date,
        //         revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
        //         revised_bid_price_unit_rate_of_freight: detail.revised_bid_price_unit_rate_of_freight,
        //         revised_bid_price_total_unit_rate: detail.revised_bid_price_total_unit_rate,
        //         revised_bid_price_date: detail.revised_bid_price_date,
        //         final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
        //         final_bid_price_unit_rate_of_freight: detail.final_bid_price_unit_rate_of_freight,
        //         final_bid_price_total_unit_rate: detail.final_bid_price_total_unit_rate,
        //         final_bid_price_date: detail.final_bid_price_date,
        //       })),
        //     })),
        //   })),
        // };
        const newState2 = {
          // state.bid_rfq_vendor_detail[record.key]?.bid_rfq_detail[
          //   siteIndex
          // ]?.initial_bid_price_unit_rate
          vendor: VendorId,
          // ...responseData.data.data.map((item) => ({
          // rfq_material_type_name: item.rfq_material_type_name,
          // rfq_material_type: item.rfq_material_type_id,
          bid_rfq_vendor_detail:
            responseData.data.data[0].rfq_site_wise_vendor.map((site) => ({
              // company: site.company,
              // rfq_number: site.rfq_number,
              rfq_material_type_name: site.rfq_material_type_name,
              rfq_material_type: site.rfq_material_type_id,
              bid_rfq_detail: site.bid_rfq_detail.map((detail) => ({
                id: detail.bid_rfq_id,
                rfq_vendor_detail: detail.rfq_vendor_detail_id,
                purchase_requisition_site_id:
                  detail.purchase_requisition_site_id,
                purchase_requisition_site_name:
                  detail.purchase_requisition_site_name,
                site_wise_total_quantity: detail.site_wise_total_quantity,
                initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight,
                initial_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate,
                initial_bid_price_date: detail.initial_bid_price_date,
                revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
                revised_bid_price_unit_rate_of_freight:
                  detail.revised_bid_price_unit_rate_of_freight,
                revised_bid_price_total_unit_rate:
                  detail.revised_bid_price_total_unit_rate,
                // revised_bid_price_date: detail.revised_bid_price_date,
                revised_bid_price_date: currentDate,
                final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
                final_bid_price_unit_rate_of_freight:
                  detail.final_bid_price_unit_rate_of_freight,
                final_bid_price_total_unit_rate:
                  detail.final_bid_price_total_unit_rate,
                final_bid_price_date: currentDate,
              })),
            })),
          // })),
        };

        setNewState2(newState2);
        console.log(newState2, "newstate2");
        setState(newState2);
        // setState((prevState) => ({
        //   ...prevState,
        //   // ...newState2,
        // }));
        // Process anotherResponse accordingly
        console.log("Response from another API call:", responseData);

        setTrackingOfStages((trackingOfStages) => trackingOfStages + 1);
        if (state?.is_final_bid_price === true) {
          // console.log("Inside if track===3");
          navigate(`/rfq-vendor-request-for-quotation/history/${CategoryId}`);
        }
        if (trackingOfStages === 2) {
          navigate(`/rfq-vendor-request-for-quotation/history/${CategoryId}`);
        }
        SuccessNotificationMsg(
          // CompanyId
          // ? t("business_setting_updated_successfully")
          t("bidding_of_R0")
        );
      }
      //     // setState(initialState);
      //     //formRef.current.setFieldsValue(initialState);
      //    // setBtnLoading(false);
      //     //setapiLoading(false);
      //     //navigate("/pr-approval-heirarchy-list");
    } catch (error) {
      ErrorNotificationMsg(
        t("error_in_bidding")
        // CompanyId
        //   ? t("business_setting_updated_successfully")
        //   : t("business_setting_added_successfully")
      );
      setLoading(false);
    }
  };

  const handleSubmitPatch = async () => {
    const payload = {
      ...state,
    };

    // const payload = {

    //   vendor: VendorId,
    //   //id: patchId,

    //   is_final_bid_price: state.is_final_bid_price,
    //   // bid_rfq_vendor_detail: state.bid_rfq_vendor_detail,
    //   bid_rfq_vendor_detail: state.bid_rfq_vendor_detail.map((item) => ({
    //     //buying_pattern: item.buying_pattern,
    //     // comment
    //     rfq_material_type: item.rfq_material_type,

    //     // gst_rate: item.gst_rate,
    //     // estimated_unit_price: item.estimated_unit_price,

    //     //total_of_R0: calculateTotalUnitRateOfCementR0(item),
    //     // total_of_cement_R0: item.bid_rfq_site_detail.reduce((total, detail) => total + (parseFloat(detail.totalUnitRateOfCementR0) || 0), 0),
    //     // total_of_R0: calculateTotalR0(item.bid_rfq_site_detail),
    //     bid_rfq_detail: item.bid_rfq_detail.map((detail) => ({
    //       // purchase_requisition_site_id: detail.purchase_requisition_site_id,
    //       //id: patchId,
    //       // bid_rfq_id: bidRfqIds[0],
    //       bid_rfq_id: detail.bid_rfq_id,
    //       rfq_vendor_detail: detail.rfq_vendor_detail, // Displaying "rfq_vendor_detail_id" as "rfq_vendor_detail"
    //       initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
    //       initial_bid_price_unit_rate_of_freight:
    //         detail.initial_bid_price_unit_rate_of_freight,
    //       initial_bid_price_total_unit_rate:
    //         detail.initial_bid_price_total_unit_rate,
    //       initial_bid_price_date: detail.initial_bid_price_date,
    //       revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
    //       revised_bid_price_unit_rate_of_freight:
    //         detail.revised_bid_price_unit_rate_of_freight,
    //       revised_bid_price_total_unit_rate:
    //         detail.revised_bid_price_total_unit_rate,
    //       revised_bid_price_date: detail.revised_bid_price_date,
    //       final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
    //       final_bid_price_unit_rate_of_freight:
    //         detail.final_bid_price_unit_rate_of_freight,
    //       final_bid_price_total_unit_rate:
    //         detail.final_bid_price_total_unit_rate,
    //       final_bid_price_date: detail.final_bid_price_date,
    //       // gst_inclusive_unit_rate: detail.gst_inclusive_unit_rate,
    //       // amount_without_gst: detail.amount_without_gst,
    //       // amount_with_gst: detail.amount_with_gst,
    //       //totalUnitRateOfCementR0: detail.totalUnitRateOfCementR0,
    //       //total_of_R0: detail.total_of_R0,
    //     })),

    //     // total_of_R0: item.bid_rfq_site_detail.reduce((total, detail) => total + (parseFloat(detail.total_of_R0) || 0), 0),
    //   })),

    // };

    try {
      setLoading(true);
      // setapiLoading(true);
      let response;
      response = await patchRequest(`bid-rfq/${vendorBidId}/`, payload);

      if (response.data.success) {
        // setAddedCompanyId(response.data.data.id);
        setLoading(false);
        setTrackingOfStages((trackingOfStages) => trackingOfStages + 1);
        if (state?.is_final_bid_price === true) {
          // console.log("Inside if track===3");
          navigate(`/rfq-vendor-request-for-quotation/history${CategoryId}`);
        }




















        if (trackingOfStages === 0) {
          SuccessNotificationMsg(
            // CompanyId
            //   ? t("business_setting_updated_successfully")
            t("bidding_of_R0")
          );
        }
        if (trackingOfStages === 1) {
          SuccessNotificationMsg(
            // CompanyId
            //   ? t("business_setting_updated_successfully")
            t("bidding_of_R1")
          );
        }
        if (trackingOfStages === 2) {
          SuccessNotificationMsg(
            // CompanyId
            //   ? t("business_setting_updated_successfully")
            t("bidding_of_R")
          );
        }
        if (trackingOfStages === 2) {
          navigate(`/rfq-vendor-request-for-quotation/history/${CategoryId}`);
        }
      }
      //     // setState(initialState);
      //     //formRef.current.setFieldsValue(initialState);
      //    // setBtnLoading(false);
      //     //setapiLoading(false);
      //     //navigate("/pr-approval-heirarchy-list");
    } catch (error) {
      ErrorNotificationMsg(
        //  CompanyId
        //    ? t("business_setting_updated_successfully")
        t("error_in_bidding")
      );
      setLoading(false);
    }
  };

  const filteredColumns = columns.filter((column) => !column.hidden);

  

  
 const handleDisable = () => {
    switch (trackingOfStages) {
        case 0:
            return disabled;
        case 1:
            return disabled1;
        case 2:
            return disabled2;
        default:
            return false; 
    }
};

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>BID RFQ - Vendor</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/rfq-vendor-request-for-quotation/history/1">RFQ History</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>BID RFQ</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec mt-5">

        <div className="PR-body">
          <Collapse defaultActiveKey={[1]} key={1} className="rgqdtlcollapse">
            <Panel header={"RFQ Details"} key={1}>
              <div className="rgq-num-wrap wrap">
                <h5 className="rfq-number new">
                  Company Name : <span>{companyName}</span>
                </h5>
                <h5 className="rfq-number new">
                  RFQ Number : <span>{rfqnumber}</span>
                </h5>
                <h5 className="rfq-number new">
                  Currency : <span>{rfqcurrency}</span>
                </h5>
                <h5 className="rfq-number new">
                  Price Basis : <span>{rfqpricebasis}</span>
                </h5>
                <h5 className="rfq-number new">
                  Freight : <span>{rfqfreight}</span>
                </h5>
                <h5 className="rfq-number new">
                  Unloading : <span>{rfqunloading}</span>
                </h5>
                <h5 className="rfq-number new">
                  Transport Insurance : <span>{rfqtransportInsurance}</span>
                </h5>
                <h5 className="rfq-number new">
                  RFQ Due Date : <span>{rfqData.rfqduedate}</span>
                </h5>
                {/* <h5 className="rfq-number new">
                Open Order : <span>{rfqopenorder}</span>
              </h5> */}
                {/* <>
                {!rfqopenorder && (
                  <>
                    <h5 className="rfq-number new">
                      Amount Cap : <span>{rfqamountcap}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      Timeline Cap : <span>{rfqtimelinecap}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      Delivery Date : <span>{rfqopendeliverydate}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      Delivery Start Date : <span>{rfqdeliverystartdate}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      Delivery End Date : <span>{rfqdeliveryenddate}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      RFQ Due Date : <span>{rfqduedate}</span>
                    </h5>
                    <h5 className="rfq-number new">
                      Price Cap : <span>{rfqpricecap}</span>
                    </h5>
                  </>
                )}
              </> */}
                {!rfqData.open_order && (
                  <h5 className="rfq-number new">
                    Delivery Date : <span>{rfqData.rfqopendeliverydate}</span>
                  </h5>
                )}

                <>
                  {rfqData.open_order && (
                    <>
                      <h5 className="rfq-number new">
                        Amount Cap : <span>{rfqData.rfqamountcap}</span>
                      </h5>
                      <h5 className="rfq-number new">
                        Timeline Cap : <span>{rfqData.rfqtimelinecap}</span>
                      </h5>
                      {/* <h5 className="rfq-number new">
                      Delivery Date : <span>{rfqData.rfqopendeliverydate}</span>
                    </h5> */}
                      <h5 className="rfq-number new">
                        Delivery Start Date :{" "}
                        <span>{rfqData.rfqdeliverystartdate}</span>
                      </h5>
                      <h5 className="rfq-number new">
                        Delivery End Date :{" "}
                        <span>{rfqData.rfqdeliveryenddate}</span>
                      </h5>

                      <h5 className="rfq-number new">
                        Price Cap : <span>{rfqData.rfqpricecap}</span>
                      </h5>
                    </>
                  )}
                </>
                <>
                  <div>
                    {showAdditionalCheckboxesFinal && (
                      <>
                        <Checkbox onChange={handleCheckboxChange}>
                          Is This Your Final Bid Price?
                        </Checkbox>
                      </>
                    )}
                    {showAdditionalCheckboxes && (
                      <>
                        <Checkbox
                          checked={
                            hideInitialBIDPriceCementR0 &&
                            hideInitialBIDPriceFreightR0
                          }
                          onChange={toggleHideInitialBIDPriceR0}
                        >
                          Hide Initial BID Price - R0
                        </Checkbox>
                        <Checkbox
                          checked={
                            hideInitialBIDPriceCementR1 &&
                            hideInitialBIDPriceFreightR1
                          }
                          onChange={toggleHideInitialBIDPriceR1}
                        >
                          Hide BID Price - R1
                        </Checkbox>
                      </>
                    )}
                  </div>
                </>
              </div>
            </Panel>
          </Collapse>
          <Form autoComplete="off" ref={formRef} onFinish={handleSubmit}>
          <Spin spinning={apiLoading}>
            <Table
              className="rfqcustomtbl"
              dataSource={vendorBidRFQ}
              bordered
              scroll={{
                x: 2000,
              }}
              columns={filteredColumns}
              pagination={false}
            />
            </Spin>
            <div className="footerTable">
              <Table
                columns={columns2}
                dataSource={filteredData}
                pagination={false}
              />
            </div>
            <div className="FormFooter bidftr">
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("cancel")}
              // onClick={() => navigate("/vendor")}
              />
              <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                htmlType="button"
                label="Submit BID"
                onClick={handleBidSubmission}
                loading={loading}
                // disabled={
                // trackingOfStages === 0 ? disabled :
                // trackingOfStages === 1 ? disabled1 :
                // trackingOfStages === 2 ? disabled2 :
                // true
                // }
                // disabled={handleDisable}
                disabled={disabled}
              />
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};

export default VendorBidRFQ;
